/* tslint:disable */
/* eslint-disable */
/**
 * Solar Schools - Public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: dev@solarschools.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, BaseAPI } from './base';
/**
 * APIKeysApi - axios parameter creator
 * @export
 */
export const APIKeysApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('_delete', 'id', id);
            const localVarPath = `/api-keys/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CreateApiKey} [createApiKey] Payload for creating an existing API key.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: (createApiKey, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api-keys/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createApiKey, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('get', 'id', id);
            const localVarPath = `/api-keys/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [key] Key filter.
         * @param {string} [name] Name filter.
         * @param {string} [status] Status filter.
         * @param {string} [userId] User ID filter.
         * @param {string} [userEmail] User email filter.
         * @param {number} [page] Page of results to return.
         * @param {number} [limit] Limit of results to return.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list: (key, name, status, userId, userEmail, page, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api-keys/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }
            if (userEmail !== undefined) {
                localVarQueryParameter['userEmail'] = userEmail;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {UpdateApiKey} [updateApiKey] Payload for updating an existing API key.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: (id, updateApiKey, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id);
            const localVarPath = `/api-keys/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateApiKey, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * APIKeysApi - functional programming interface
 * @export
 */
export const APIKeysApiFp = function (configuration) {
    const localVarAxiosParamCreator = APIKeysApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator._delete(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {CreateApiKey} [createApiKey] Payload for creating an existing API key.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createApiKey, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.create(createApiKey, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.get(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} [key] Key filter.
         * @param {string} [name] Name filter.
         * @param {string} [status] Status filter.
         * @param {string} [userId] User ID filter.
         * @param {string} [userEmail] User email filter.
         * @param {number} [page] Page of results to return.
         * @param {number} [limit] Limit of results to return.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(key, name, status, userId, userEmail, page, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.list(key, name, status, userId, userEmail, page, limit, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {UpdateApiKey} [updateApiKey] Payload for updating an existing API key.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id, updateApiKey, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.update(id, updateApiKey, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * APIKeysApi - factory interface
 * @export
 */
export const APIKeysApiFactory = function (configuration, basePath, axios) {
    const localVarFp = APIKeysApiFp(configuration);
    return {
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(id, options) {
            return localVarFp._delete(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateApiKey} [createApiKey] Payload for creating an existing API key.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createApiKey, options) {
            return localVarFp.create(createApiKey, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id, options) {
            return localVarFp.get(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [key] Key filter.
         * @param {string} [name] Name filter.
         * @param {string} [status] Status filter.
         * @param {string} [userId] User ID filter.
         * @param {string} [userEmail] User email filter.
         * @param {number} [page] Page of results to return.
         * @param {number} [limit] Limit of results to return.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(key, name, status, userId, userEmail, page, limit, options) {
            return localVarFp.list(key, name, status, userId, userEmail, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {UpdateApiKey} [updateApiKey] Payload for updating an existing API key.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id, updateApiKey, options) {
            return localVarFp.update(id, updateApiKey, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * APIKeysApi - object-oriented interface
 * @export
 * @class APIKeysApi
 * @extends {BaseAPI}
 */
export class APIKeysApi extends BaseAPI {
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIKeysApi
     */
    _delete(id, options) {
        return APIKeysApiFp(this.configuration)._delete(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CreateApiKey} [createApiKey] Payload for creating an existing API key.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIKeysApi
     */
    create(createApiKey, options) {
        return APIKeysApiFp(this.configuration).create(createApiKey, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIKeysApi
     */
    get(id, options) {
        return APIKeysApiFp(this.configuration).get(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [key] Key filter.
     * @param {string} [name] Name filter.
     * @param {string} [status] Status filter.
     * @param {string} [userId] User ID filter.
     * @param {string} [userEmail] User email filter.
     * @param {number} [page] Page of results to return.
     * @param {number} [limit] Limit of results to return.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIKeysApi
     */
    list(key, name, status, userId, userEmail, page, limit, options) {
        return APIKeysApiFp(this.configuration).list(key, name, status, userId, userEmail, page, limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {UpdateApiKey} [updateApiKey] Payload for updating an existing API key.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIKeysApi
     */
    update(id, updateApiKey, options) {
        return APIKeysApiFp(this.configuration).update(id, updateApiKey, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AuthenticationApi - axios parameter creator
 * @export
 */
export const AuthenticationApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {ForgotPassword} [forgotPassword] Payload for initiating a forgot password flow.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgotPassword: (forgotPassword, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/authentication/forgot-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(forgotPassword, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Login} [login] Payload for logging in a user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: (login, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/authentication/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(login, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Logout} [logout] Payload for logging out a user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: (logout, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/authentication/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(logout, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [attachUser] Attach the user to the response data.
         * @param {RefreshSession} [refreshSession] Payload for refreshing a user session.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshSession: (attachUser, refreshSession, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/authentication/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (attachUser !== undefined) {
                localVarQueryParameter['attachUser'] = attachUser;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(refreshSession, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ResetPassword} [resetPassword] Payload for resetting a user password.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword: (resetPassword, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/authentication/reset-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(resetPassword, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testAccess: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/authentication/access-test`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AuthenticationApi - functional programming interface
 * @export
 */
export const AuthenticationApiFp = function (configuration) {
    const localVarAxiosParamCreator = AuthenticationApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {ForgotPassword} [forgotPassword] Payload for initiating a forgot password flow.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgotPassword(forgotPassword, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.forgotPassword(forgotPassword, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {Login} [login] Payload for logging in a user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(login, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.login(login, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {Logout} [logout] Payload for logging out a user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(logout, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.logout(logout, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} [attachUser] Attach the user to the response data.
         * @param {RefreshSession} [refreshSession] Payload for refreshing a user session.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshSession(attachUser, refreshSession, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.refreshSession(attachUser, refreshSession, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {ResetPassword} [resetPassword] Payload for resetting a user password.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword(resetPassword, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.resetPassword(resetPassword, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testAccess(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.testAccess(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AuthenticationApi - factory interface
 * @export
 */
export const AuthenticationApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AuthenticationApiFp(configuration);
    return {
        /**
         *
         * @param {ForgotPassword} [forgotPassword] Payload for initiating a forgot password flow.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgotPassword(forgotPassword, options) {
            return localVarFp.forgotPassword(forgotPassword, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Login} [login] Payload for logging in a user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(login, options) {
            return localVarFp.login(login, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Logout} [logout] Payload for logging out a user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(logout, options) {
            return localVarFp.logout(logout, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [attachUser] Attach the user to the response data.
         * @param {RefreshSession} [refreshSession] Payload for refreshing a user session.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshSession(attachUser, refreshSession, options) {
            return localVarFp.refreshSession(attachUser, refreshSession, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ResetPassword} [resetPassword] Payload for resetting a user password.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword(resetPassword, options) {
            return localVarFp.resetPassword(resetPassword, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testAccess(options) {
            return localVarFp.testAccess(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AuthenticationApi - object-oriented interface
 * @export
 * @class AuthenticationApi
 * @extends {BaseAPI}
 */
export class AuthenticationApi extends BaseAPI {
    /**
     *
     * @param {ForgotPassword} [forgotPassword] Payload for initiating a forgot password flow.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    forgotPassword(forgotPassword, options) {
        return AuthenticationApiFp(this.configuration).forgotPassword(forgotPassword, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Login} [login] Payload for logging in a user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    login(login, options) {
        return AuthenticationApiFp(this.configuration).login(login, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Logout} [logout] Payload for logging out a user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    logout(logout, options) {
        return AuthenticationApiFp(this.configuration).logout(logout, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [attachUser] Attach the user to the response data.
     * @param {RefreshSession} [refreshSession] Payload for refreshing a user session.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    refreshSession(attachUser, refreshSession, options) {
        return AuthenticationApiFp(this.configuration).refreshSession(attachUser, refreshSession, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ResetPassword} [resetPassword] Payload for resetting a user password.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    resetPassword(resetPassword, options) {
        return AuthenticationApiFp(this.configuration).resetPassword(resetPassword, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    testAccess(options) {
        return AuthenticationApiFp(this.configuration).testAccess(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AuthorizationApi - axios parameter creator
 * @export
 */
export const AuthorizationApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} resourceType Type of the resource.
         * @param {string} intent
         * @param {number} [resourceId] ID of the resource.
         * @param {boolean} [write]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testPermission: (resourceType, intent, resourceId, write, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'resourceType' is not null or undefined
            assertParamExists('testPermission', 'resourceType', resourceType);
            // verify required parameter 'intent' is not null or undefined
            assertParamExists('testPermission', 'intent', intent);
            const localVarPath = `/authorization/test-permission`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            if (resourceType !== undefined) {
                localVarQueryParameter['resourceType'] = resourceType;
            }
            if (resourceId !== undefined) {
                localVarQueryParameter['resourceId'] = resourceId;
            }
            if (intent !== undefined) {
                localVarQueryParameter['intent'] = intent;
            }
            if (write !== undefined) {
                localVarQueryParameter['write'] = write;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AuthorizationApi - functional programming interface
 * @export
 */
export const AuthorizationApiFp = function (configuration) {
    const localVarAxiosParamCreator = AuthorizationApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} resourceType Type of the resource.
         * @param {string} intent
         * @param {number} [resourceId] ID of the resource.
         * @param {boolean} [write]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testPermission(resourceType, intent, resourceId, write, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.testPermission(resourceType, intent, resourceId, write, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AuthorizationApi - factory interface
 * @export
 */
export const AuthorizationApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AuthorizationApiFp(configuration);
    return {
        /**
         *
         * @param {string} resourceType Type of the resource.
         * @param {string} intent
         * @param {number} [resourceId] ID of the resource.
         * @param {boolean} [write]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testPermission(resourceType, intent, resourceId, write, options) {
            return localVarFp.testPermission(resourceType, intent, resourceId, write, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AuthorizationApi - object-oriented interface
 * @export
 * @class AuthorizationApi
 * @extends {BaseAPI}
 */
export class AuthorizationApi extends BaseAPI {
    /**
     *
     * @param {string} resourceType Type of the resource.
     * @param {string} intent
     * @param {number} [resourceId] ID of the resource.
     * @param {boolean} [write]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorizationApi
     */
    testPermission(resourceType, intent, resourceId, write, options) {
        return AuthorizationApiFp(this.configuration).testPermission(resourceType, intent, resourceId, write, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ContractorsApi - axios parameter creator
 * @export
 */
export const ContractorsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('_delete', 'id', id);
            const localVarPath = `/contractors/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CreateContractor} [createContractor] Payload for creating a new contractor.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: (createContractor, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/contractors/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createContractor, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('get', 'id', id);
            const localVarPath = `/contractors/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/contractors/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {UpdateContractor} [updateContractor] Payload for updating an existing contractor.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: (id, updateContractor, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id);
            const localVarPath = `/contractors/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateContractor, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ContractorsApi - functional programming interface
 * @export
 */
export const ContractorsApiFp = function (configuration) {
    const localVarAxiosParamCreator = ContractorsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator._delete(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {CreateContractor} [createContractor] Payload for creating a new contractor.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createContractor, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.create(createContractor, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.get(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.list(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {UpdateContractor} [updateContractor] Payload for updating an existing contractor.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id, updateContractor, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.update(id, updateContractor, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ContractorsApi - factory interface
 * @export
 */
export const ContractorsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ContractorsApiFp(configuration);
    return {
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(id, options) {
            return localVarFp._delete(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateContractor} [createContractor] Payload for creating a new contractor.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createContractor, options) {
            return localVarFp.create(createContractor, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id, options) {
            return localVarFp.get(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(options) {
            return localVarFp.list(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {UpdateContractor} [updateContractor] Payload for updating an existing contractor.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id, updateContractor, options) {
            return localVarFp.update(id, updateContractor, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ContractorsApi - object-oriented interface
 * @export
 * @class ContractorsApi
 * @extends {BaseAPI}
 */
export class ContractorsApi extends BaseAPI {
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorsApi
     */
    _delete(id, options) {
        return ContractorsApiFp(this.configuration)._delete(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CreateContractor} [createContractor] Payload for creating a new contractor.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorsApi
     */
    create(createContractor, options) {
        return ContractorsApiFp(this.configuration).create(createContractor, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorsApi
     */
    get(id, options) {
        return ContractorsApiFp(this.configuration).get(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorsApi
     */
    list(options) {
        return ContractorsApiFp(this.configuration).list(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {UpdateContractor} [updateContractor] Payload for updating an existing contractor.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorsApi
     */
    update(id, updateContractor, options) {
        return ContractorsApiFp(this.configuration).update(id, updateContractor, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * DataApi - axios parameter creator
 * @export
 */
export const DataApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} resourceType Type of the resource.
         * @param {number} resourceId ID of the resource.
         * @param {string} type The type of data to return.
         * @param {string} start The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
         * @param {string} [period] Pre-defined period of time to retrieve.
         * @param {string} [end] The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - format without a timezone.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChildEnergyBreakdown: (resourceType, resourceId, type, start, period, end, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'resourceType' is not null or undefined
            assertParamExists('getChildEnergyBreakdown', 'resourceType', resourceType);
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('getChildEnergyBreakdown', 'resourceId', resourceId);
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getChildEnergyBreakdown', 'type', type);
            // verify required parameter 'start' is not null or undefined
            assertParamExists('getChildEnergyBreakdown', 'start', start);
            const localVarPath = `/data/{resourceType}/{resourceId}/energy/child-breakdown`
                .replace(`{${"resourceType"}}`, encodeURIComponent(String(resourceType)))
                .replace(`{${"resourceId"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            // authentication ApiSoftAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (period !== undefined) {
                localVarQueryParameter['period'] = period;
            }
            if (start !== undefined) {
                localVarQueryParameter['start'] = start;
            }
            if (end !== undefined) {
                localVarQueryParameter['end'] = end;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} resourceType Type of the resource.
         * @param {number} resourceId ID of the resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChildEnergyStats: (resourceType, resourceId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'resourceType' is not null or undefined
            assertParamExists('getChildEnergyStats', 'resourceType', resourceType);
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('getChildEnergyStats', 'resourceId', resourceId);
            const localVarPath = `/data/{resourceType}/{resourceId}/energy/child-stats`
                .replace(`{${"resourceType"}}`, encodeURIComponent(String(resourceType)))
                .replace(`{${"resourceId"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            // authentication ApiSoftAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} resourceType Type of the resource.
         * @param {number} resourceId ID of the resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChildSolarStats: (resourceType, resourceId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'resourceType' is not null or undefined
            assertParamExists('getChildSolarStats', 'resourceType', resourceType);
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('getChildSolarStats', 'resourceId', resourceId);
            const localVarPath = `/data/{resourceType}/{resourceId}/solar/child-stats`
                .replace(`{${"resourceType"}}`, encodeURIComponent(String(resourceType)))
                .replace(`{${"resourceId"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} resourceType Type of the resource.
         * @param {number} resourceId ID of the resource.
         * @param {string} start The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
         * @param {string} [end] The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - format without a timezone.
         * @param {string} [aggregation] Suggested aggregation of the data. Is not guaranteed if date range is too large for the aggregation type. 5 minute, 30 minute, day, month or year.
         * @param {boolean} [weather] Attach weather to the data.
         * @param {boolean} [includeDisabled] Include disabled virtual meter data sources.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnergyFeed: (resourceType, resourceId, start, end, aggregation, weather, includeDisabled, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'resourceType' is not null or undefined
            assertParamExists('getEnergyFeed', 'resourceType', resourceType);
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('getEnergyFeed', 'resourceId', resourceId);
            // verify required parameter 'start' is not null or undefined
            assertParamExists('getEnergyFeed', 'start', start);
            const localVarPath = `/data/{resourceType}/{resourceId}/energy/feed`
                .replace(`{${"resourceType"}}`, encodeURIComponent(String(resourceType)))
                .replace(`{${"resourceId"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            // authentication ApiSoftAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (start !== undefined) {
                localVarQueryParameter['start'] = start;
            }
            if (end !== undefined) {
                localVarQueryParameter['end'] = end;
            }
            if (aggregation !== undefined) {
                localVarQueryParameter['aggregation'] = aggregation;
            }
            if (weather !== undefined) {
                localVarQueryParameter['weather'] = weather;
            }
            if (includeDisabled !== undefined) {
                localVarQueryParameter['includeDisabled'] = includeDisabled;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} resourceType Type of the resource.
         * @param {number} resourceId ID of the resource.
         * @param {string} [start] The date in ISO format - YYYY-MM-DD - without a timezone. If no date is provided, the data will default to lifetime.
         * @param {string} [end] The date in ISO format - YYYY-MM-DD - without a timezone.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnergyStats: (resourceType, resourceId, start, end, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'resourceType' is not null or undefined
            assertParamExists('getEnergyStats', 'resourceType', resourceType);
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('getEnergyStats', 'resourceId', resourceId);
            const localVarPath = `/data/{resourceType}/{resourceId}/energy/stats`
                .replace(`{${"resourceType"}}`, encodeURIComponent(String(resourceType)))
                .replace(`{${"resourceId"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            // authentication ApiSoftAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (start !== undefined) {
                localVarQueryParameter['start'] = start;
            }
            if (end !== undefined) {
                localVarQueryParameter['end'] = end;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} resourceType Type of the resource.
         * @param {number} resourceId ID of the resource.
         * @param {string} [order] Ordering of the ranking.
         * @param {boolean} [averageByPopulation] Should the consumption be averaged by the site\&#39;s population?
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSitesEnergyRanking: (resourceType, resourceId, order, averageByPopulation, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'resourceType' is not null or undefined
            assertParamExists('getSitesEnergyRanking', 'resourceType', resourceType);
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('getSitesEnergyRanking', 'resourceId', resourceId);
            const localVarPath = `/data/{resourceType}/{resourceId}/sites/energy/ranking`
                .replace(`{${"resourceType"}}`, encodeURIComponent(String(resourceType)))
                .replace(`{${"resourceId"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (averageByPopulation !== undefined) {
                localVarQueryParameter['averageByPopulation'] = averageByPopulation;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} resourceType Type of the resource; schemas, organisations, sites or meters.
         * @param {number} resourceId ID of the resource.
         * @param {string} start The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
         * @param {string} [end] The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - format without a timezone.
         * @param {string} [aggregation] Suggested aggregation of the data. Is not guaranteed if date range is too large for the aggregation type. 15 minute, day, month or year.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterFeed: (resourceType, resourceId, start, end, aggregation, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'resourceType' is not null or undefined
            assertParamExists('getWaterFeed', 'resourceType', resourceType);
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('getWaterFeed', 'resourceId', resourceId);
            // verify required parameter 'start' is not null or undefined
            assertParamExists('getWaterFeed', 'start', start);
            const localVarPath = `/data/{resourceType}/{resourceId}/water/feed`
                .replace(`{${"resourceType"}}`, encodeURIComponent(String(resourceType)))
                .replace(`{${"resourceId"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (start !== undefined) {
                localVarQueryParameter['start'] = start;
            }
            if (end !== undefined) {
                localVarQueryParameter['end'] = end;
            }
            if (aggregation !== undefined) {
                localVarQueryParameter['aggregation'] = aggregation;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} resourceType Type of the resource; schemas, organisations, sites or meters.
         * @param {number} resourceId ID of the resource.
         * @param {string} [start] The date in ISO format - YYYY-MM-DD - without a timezone. If no date is provided, the data will default to lifetime.
         * @param {string} [end] The date in ISO format - YYYY-MM-DD - without a timezone.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterStats: (resourceType, resourceId, start, end, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'resourceType' is not null or undefined
            assertParamExists('getWaterStats', 'resourceType', resourceType);
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('getWaterStats', 'resourceId', resourceId);
            const localVarPath = `/data/{resourceType}/{resourceId}/water/stats`
                .replace(`{${"resourceType"}}`, encodeURIComponent(String(resourceType)))
                .replace(`{${"resourceId"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (start !== undefined) {
                localVarQueryParameter['start'] = start;
            }
            if (end !== undefined) {
                localVarQueryParameter['end'] = end;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * DataApi - functional programming interface
 * @export
 */
export const DataApiFp = function (configuration) {
    const localVarAxiosParamCreator = DataApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} resourceType Type of the resource.
         * @param {number} resourceId ID of the resource.
         * @param {string} type The type of data to return.
         * @param {string} start The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
         * @param {string} [period] Pre-defined period of time to retrieve.
         * @param {string} [end] The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - format without a timezone.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChildEnergyBreakdown(resourceType, resourceId, type, start, period, end, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getChildEnergyBreakdown(resourceType, resourceId, type, start, period, end, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} resourceType Type of the resource.
         * @param {number} resourceId ID of the resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChildEnergyStats(resourceType, resourceId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getChildEnergyStats(resourceType, resourceId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} resourceType Type of the resource.
         * @param {number} resourceId ID of the resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChildSolarStats(resourceType, resourceId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getChildSolarStats(resourceType, resourceId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} resourceType Type of the resource.
         * @param {number} resourceId ID of the resource.
         * @param {string} start The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
         * @param {string} [end] The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - format without a timezone.
         * @param {string} [aggregation] Suggested aggregation of the data. Is not guaranteed if date range is too large for the aggregation type. 5 minute, 30 minute, day, month or year.
         * @param {boolean} [weather] Attach weather to the data.
         * @param {boolean} [includeDisabled] Include disabled virtual meter data sources.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnergyFeed(resourceType, resourceId, start, end, aggregation, weather, includeDisabled, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getEnergyFeed(resourceType, resourceId, start, end, aggregation, weather, includeDisabled, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} resourceType Type of the resource.
         * @param {number} resourceId ID of the resource.
         * @param {string} [start] The date in ISO format - YYYY-MM-DD - without a timezone. If no date is provided, the data will default to lifetime.
         * @param {string} [end] The date in ISO format - YYYY-MM-DD - without a timezone.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnergyStats(resourceType, resourceId, start, end, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getEnergyStats(resourceType, resourceId, start, end, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} resourceType Type of the resource.
         * @param {number} resourceId ID of the resource.
         * @param {string} [order] Ordering of the ranking.
         * @param {boolean} [averageByPopulation] Should the consumption be averaged by the site\&#39;s population?
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSitesEnergyRanking(resourceType, resourceId, order, averageByPopulation, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSitesEnergyRanking(resourceType, resourceId, order, averageByPopulation, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} resourceType Type of the resource; schemas, organisations, sites or meters.
         * @param {number} resourceId ID of the resource.
         * @param {string} start The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
         * @param {string} [end] The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - format without a timezone.
         * @param {string} [aggregation] Suggested aggregation of the data. Is not guaranteed if date range is too large for the aggregation type. 15 minute, day, month or year.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterFeed(resourceType, resourceId, start, end, aggregation, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getWaterFeed(resourceType, resourceId, start, end, aggregation, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} resourceType Type of the resource; schemas, organisations, sites or meters.
         * @param {number} resourceId ID of the resource.
         * @param {string} [start] The date in ISO format - YYYY-MM-DD - without a timezone. If no date is provided, the data will default to lifetime.
         * @param {string} [end] The date in ISO format - YYYY-MM-DD - without a timezone.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterStats(resourceType, resourceId, start, end, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getWaterStats(resourceType, resourceId, start, end, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * DataApi - factory interface
 * @export
 */
export const DataApiFactory = function (configuration, basePath, axios) {
    const localVarFp = DataApiFp(configuration);
    return {
        /**
         *
         * @param {string} resourceType Type of the resource.
         * @param {number} resourceId ID of the resource.
         * @param {string} type The type of data to return.
         * @param {string} start The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
         * @param {string} [period] Pre-defined period of time to retrieve.
         * @param {string} [end] The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - format without a timezone.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChildEnergyBreakdown(resourceType, resourceId, type, start, period, end, options) {
            return localVarFp.getChildEnergyBreakdown(resourceType, resourceId, type, start, period, end, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} resourceType Type of the resource.
         * @param {number} resourceId ID of the resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChildEnergyStats(resourceType, resourceId, options) {
            return localVarFp.getChildEnergyStats(resourceType, resourceId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} resourceType Type of the resource.
         * @param {number} resourceId ID of the resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChildSolarStats(resourceType, resourceId, options) {
            return localVarFp.getChildSolarStats(resourceType, resourceId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} resourceType Type of the resource.
         * @param {number} resourceId ID of the resource.
         * @param {string} start The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
         * @param {string} [end] The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - format without a timezone.
         * @param {string} [aggregation] Suggested aggregation of the data. Is not guaranteed if date range is too large for the aggregation type. 5 minute, 30 minute, day, month or year.
         * @param {boolean} [weather] Attach weather to the data.
         * @param {boolean} [includeDisabled] Include disabled virtual meter data sources.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnergyFeed(resourceType, resourceId, start, end, aggregation, weather, includeDisabled, options) {
            return localVarFp.getEnergyFeed(resourceType, resourceId, start, end, aggregation, weather, includeDisabled, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} resourceType Type of the resource.
         * @param {number} resourceId ID of the resource.
         * @param {string} [start] The date in ISO format - YYYY-MM-DD - without a timezone. If no date is provided, the data will default to lifetime.
         * @param {string} [end] The date in ISO format - YYYY-MM-DD - without a timezone.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnergyStats(resourceType, resourceId, start, end, options) {
            return localVarFp.getEnergyStats(resourceType, resourceId, start, end, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} resourceType Type of the resource.
         * @param {number} resourceId ID of the resource.
         * @param {string} [order] Ordering of the ranking.
         * @param {boolean} [averageByPopulation] Should the consumption be averaged by the site\&#39;s population?
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSitesEnergyRanking(resourceType, resourceId, order, averageByPopulation, options) {
            return localVarFp.getSitesEnergyRanking(resourceType, resourceId, order, averageByPopulation, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} resourceType Type of the resource; schemas, organisations, sites or meters.
         * @param {number} resourceId ID of the resource.
         * @param {string} start The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
         * @param {string} [end] The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - format without a timezone.
         * @param {string} [aggregation] Suggested aggregation of the data. Is not guaranteed if date range is too large for the aggregation type. 15 minute, day, month or year.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterFeed(resourceType, resourceId, start, end, aggregation, options) {
            return localVarFp.getWaterFeed(resourceType, resourceId, start, end, aggregation, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} resourceType Type of the resource; schemas, organisations, sites or meters.
         * @param {number} resourceId ID of the resource.
         * @param {string} [start] The date in ISO format - YYYY-MM-DD - without a timezone. If no date is provided, the data will default to lifetime.
         * @param {string} [end] The date in ISO format - YYYY-MM-DD - without a timezone.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterStats(resourceType, resourceId, start, end, options) {
            return localVarFp.getWaterStats(resourceType, resourceId, start, end, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * DataApi - object-oriented interface
 * @export
 * @class DataApi
 * @extends {BaseAPI}
 */
export class DataApi extends BaseAPI {
    /**
     *
     * @param {string} resourceType Type of the resource.
     * @param {number} resourceId ID of the resource.
     * @param {string} type The type of data to return.
     * @param {string} start The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
     * @param {string} [period] Pre-defined period of time to retrieve.
     * @param {string} [end] The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - format without a timezone.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataApi
     */
    getChildEnergyBreakdown(resourceType, resourceId, type, start, period, end, options) {
        return DataApiFp(this.configuration).getChildEnergyBreakdown(resourceType, resourceId, type, start, period, end, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} resourceType Type of the resource.
     * @param {number} resourceId ID of the resource.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataApi
     */
    getChildEnergyStats(resourceType, resourceId, options) {
        return DataApiFp(this.configuration).getChildEnergyStats(resourceType, resourceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} resourceType Type of the resource.
     * @param {number} resourceId ID of the resource.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataApi
     */
    getChildSolarStats(resourceType, resourceId, options) {
        return DataApiFp(this.configuration).getChildSolarStats(resourceType, resourceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} resourceType Type of the resource.
     * @param {number} resourceId ID of the resource.
     * @param {string} start The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
     * @param {string} [end] The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - format without a timezone.
     * @param {string} [aggregation] Suggested aggregation of the data. Is not guaranteed if date range is too large for the aggregation type. 5 minute, 30 minute, day, month or year.
     * @param {boolean} [weather] Attach weather to the data.
     * @param {boolean} [includeDisabled] Include disabled virtual meter data sources.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataApi
     */
    getEnergyFeed(resourceType, resourceId, start, end, aggregation, weather, includeDisabled, options) {
        return DataApiFp(this.configuration).getEnergyFeed(resourceType, resourceId, start, end, aggregation, weather, includeDisabled, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} resourceType Type of the resource.
     * @param {number} resourceId ID of the resource.
     * @param {string} [start] The date in ISO format - YYYY-MM-DD - without a timezone. If no date is provided, the data will default to lifetime.
     * @param {string} [end] The date in ISO format - YYYY-MM-DD - without a timezone.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataApi
     */
    getEnergyStats(resourceType, resourceId, start, end, options) {
        return DataApiFp(this.configuration).getEnergyStats(resourceType, resourceId, start, end, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} resourceType Type of the resource.
     * @param {number} resourceId ID of the resource.
     * @param {string} [order] Ordering of the ranking.
     * @param {boolean} [averageByPopulation] Should the consumption be averaged by the site\&#39;s population?
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataApi
     */
    getSitesEnergyRanking(resourceType, resourceId, order, averageByPopulation, options) {
        return DataApiFp(this.configuration).getSitesEnergyRanking(resourceType, resourceId, order, averageByPopulation, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} resourceType Type of the resource; schemas, organisations, sites or meters.
     * @param {number} resourceId ID of the resource.
     * @param {string} start The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
     * @param {string} [end] The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - format without a timezone.
     * @param {string} [aggregation] Suggested aggregation of the data. Is not guaranteed if date range is too large for the aggregation type. 15 minute, day, month or year.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataApi
     */
    getWaterFeed(resourceType, resourceId, start, end, aggregation, options) {
        return DataApiFp(this.configuration).getWaterFeed(resourceType, resourceId, start, end, aggregation, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} resourceType Type of the resource; schemas, organisations, sites or meters.
     * @param {number} resourceId ID of the resource.
     * @param {string} [start] The date in ISO format - YYYY-MM-DD - without a timezone. If no date is provided, the data will default to lifetime.
     * @param {string} [end] The date in ISO format - YYYY-MM-DD - without a timezone.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataApi
     */
    getWaterStats(resourceType, resourceId, start, end, options) {
        return DataApiFp(this.configuration).getWaterStats(resourceType, resourceId, start, end, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * DisplayBoardApi - axios parameter creator
 * @export
 */
export const DisplayBoardApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CreateDisplayBoard} [createDisplayBoard] Payload for creating a new display board.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: (createDisplayBoard, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/display-board/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createDisplayBoard, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} resourceType Resource type; schemas, organisations or sites.
         * @param {number} resourceId ID of the resource.
         * @param {string} [key] Key of the resource config.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: (resourceType, resourceId, key, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'resourceType' is not null or undefined
            assertParamExists('get', 'resourceType', resourceType);
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('get', 'resourceId', resourceId);
            const localVarPath = `/display-board/{resourceType}/{resourceId}`
                .replace(`{${"resourceType"}}`, encodeURIComponent(String(resourceType)))
                .replace(`{${"resourceId"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} resourceType Resource type; schemas, organisations or sites.
         * @param {number} resourceId ID of the resource.
         * @param {string} [key] Key of the resource config.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfig: (resourceType, resourceId, key, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'resourceType' is not null or undefined
            assertParamExists('getConfig', 'resourceType', resourceType);
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('getConfig', 'resourceId', resourceId);
            const localVarPath = `/display-board/config/{resourceType}/{resourceId}`
                .replace(`{${"resourceType"}}`, encodeURIComponent(String(resourceType)))
                .replace(`{${"resourceId"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} resourceType Resource type; schemas, organisations or sites.
         * @param {number} resourceId ID of the resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list: (resourceType, resourceId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'resourceType' is not null or undefined
            assertParamExists('list', 'resourceType', resourceType);
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('list', 'resourceId', resourceId);
            const localVarPath = `/display-board/{resourceType}/{resourceId}/list`
                .replace(`{${"resourceType"}}`, encodeURIComponent(String(resourceType)))
                .replace(`{${"resourceId"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} resourceType Resource type; schemas, organisations or sites.
         * @param {number} resourceId ID of the resource.
         * @param {string} [key] Key of the resource config.
         * @param {SetDisplayBoardConfig} [setDisplayBoardConfig] Payload for updating a resource\&#39;s display board config.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setConfig: (resourceType, resourceId, key, setDisplayBoardConfig, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'resourceType' is not null or undefined
            assertParamExists('setConfig', 'resourceType', resourceType);
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('setConfig', 'resourceId', resourceId);
            const localVarPath = `/display-board/config/{resourceType}/{resourceId}`
                .replace(`{${"resourceType"}}`, encodeURIComponent(String(resourceType)))
                .replace(`{${"resourceId"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(setDisplayBoardConfig, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * DisplayBoardApi - functional programming interface
 * @export
 */
export const DisplayBoardApiFp = function (configuration) {
    const localVarAxiosParamCreator = DisplayBoardApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {CreateDisplayBoard} [createDisplayBoard] Payload for creating a new display board.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createDisplayBoard, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.create(createDisplayBoard, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} resourceType Resource type; schemas, organisations or sites.
         * @param {number} resourceId ID of the resource.
         * @param {string} [key] Key of the resource config.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(resourceType, resourceId, key, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.get(resourceType, resourceId, key, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} resourceType Resource type; schemas, organisations or sites.
         * @param {number} resourceId ID of the resource.
         * @param {string} [key] Key of the resource config.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfig(resourceType, resourceId, key, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getConfig(resourceType, resourceId, key, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} resourceType Resource type; schemas, organisations or sites.
         * @param {number} resourceId ID of the resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(resourceType, resourceId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.list(resourceType, resourceId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} resourceType Resource type; schemas, organisations or sites.
         * @param {number} resourceId ID of the resource.
         * @param {string} [key] Key of the resource config.
         * @param {SetDisplayBoardConfig} [setDisplayBoardConfig] Payload for updating a resource\&#39;s display board config.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setConfig(resourceType, resourceId, key, setDisplayBoardConfig, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.setConfig(resourceType, resourceId, key, setDisplayBoardConfig, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * DisplayBoardApi - factory interface
 * @export
 */
export const DisplayBoardApiFactory = function (configuration, basePath, axios) {
    const localVarFp = DisplayBoardApiFp(configuration);
    return {
        /**
         *
         * @param {CreateDisplayBoard} [createDisplayBoard] Payload for creating a new display board.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createDisplayBoard, options) {
            return localVarFp.create(createDisplayBoard, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} resourceType Resource type; schemas, organisations or sites.
         * @param {number} resourceId ID of the resource.
         * @param {string} [key] Key of the resource config.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(resourceType, resourceId, key, options) {
            return localVarFp.get(resourceType, resourceId, key, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} resourceType Resource type; schemas, organisations or sites.
         * @param {number} resourceId ID of the resource.
         * @param {string} [key] Key of the resource config.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfig(resourceType, resourceId, key, options) {
            return localVarFp.getConfig(resourceType, resourceId, key, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} resourceType Resource type; schemas, organisations or sites.
         * @param {number} resourceId ID of the resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(resourceType, resourceId, options) {
            return localVarFp.list(resourceType, resourceId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} resourceType Resource type; schemas, organisations or sites.
         * @param {number} resourceId ID of the resource.
         * @param {string} [key] Key of the resource config.
         * @param {SetDisplayBoardConfig} [setDisplayBoardConfig] Payload for updating a resource\&#39;s display board config.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setConfig(resourceType, resourceId, key, setDisplayBoardConfig, options) {
            return localVarFp.setConfig(resourceType, resourceId, key, setDisplayBoardConfig, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * DisplayBoardApi - object-oriented interface
 * @export
 * @class DisplayBoardApi
 * @extends {BaseAPI}
 */
export class DisplayBoardApi extends BaseAPI {
    /**
     *
     * @param {CreateDisplayBoard} [createDisplayBoard] Payload for creating a new display board.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DisplayBoardApi
     */
    create(createDisplayBoard, options) {
        return DisplayBoardApiFp(this.configuration).create(createDisplayBoard, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} resourceType Resource type; schemas, organisations or sites.
     * @param {number} resourceId ID of the resource.
     * @param {string} [key] Key of the resource config.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DisplayBoardApi
     */
    get(resourceType, resourceId, key, options) {
        return DisplayBoardApiFp(this.configuration).get(resourceType, resourceId, key, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} resourceType Resource type; schemas, organisations or sites.
     * @param {number} resourceId ID of the resource.
     * @param {string} [key] Key of the resource config.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DisplayBoardApi
     */
    getConfig(resourceType, resourceId, key, options) {
        return DisplayBoardApiFp(this.configuration).getConfig(resourceType, resourceId, key, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} resourceType Resource type; schemas, organisations or sites.
     * @param {number} resourceId ID of the resource.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DisplayBoardApi
     */
    list(resourceType, resourceId, options) {
        return DisplayBoardApiFp(this.configuration).list(resourceType, resourceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} resourceType Resource type; schemas, organisations or sites.
     * @param {number} resourceId ID of the resource.
     * @param {string} [key] Key of the resource config.
     * @param {SetDisplayBoardConfig} [setDisplayBoardConfig] Payload for updating a resource\&#39;s display board config.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DisplayBoardApi
     */
    setConfig(resourceType, resourceId, key, setDisplayBoardConfig, options) {
        return DisplayBoardApiFp(this.configuration).setConfig(resourceType, resourceId, key, setDisplayBoardConfig, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * FaultsApi - axios parameter creator
 * @export
 */
export const FaultsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} resourceType Type of the resource; schemas, organisations, sites, meters or solar(-)systems.
         * @param {number} resourceId ID of the resource.
         * @param {number} [minSeverity] Minimum fault severity filter.
         * @param {number} [maxSeverity] Maximum fault severity filter.
         * @param {number} [status] Fault status filter; 0: all unresolved (default), -1: all.
         * @param {number} [type] Fault type filter.
         * @param {number} [source] Fault source filter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countResourceFaults: (resourceType, resourceId, minSeverity, maxSeverity, status, type, source, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'resourceType' is not null or undefined
            assertParamExists('countResourceFaults', 'resourceType', resourceType);
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('countResourceFaults', 'resourceId', resourceId);
            const localVarPath = `/faults/resource/{resourceType}/{resourceId}/count`
                .replace(`{${"resourceType"}}`, encodeURIComponent(String(resourceType)))
                .replace(`{${"resourceId"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            if (minSeverity !== undefined) {
                localVarQueryParameter['minSeverity'] = minSeverity;
            }
            if (maxSeverity !== undefined) {
                localVarQueryParameter['maxSeverity'] = maxSeverity;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CreateFault} [createFault] Payload for creating a new fault.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: (createFault, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/faults/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createFault, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {CreateFaultLog} [createFaultLog] Payload for creating a new log for a fault.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFaultLog: (id, createFaultLog, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createFaultLog', 'id', id);
            const localVarPath = `/faults/{id}/logs`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createFaultLog, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('get', 'id', id);
            const localVarPath = `/faults/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} resourceType Type of the resource; schemas, organisations or sites.
         * @param {number} resourceId ID of the resource.
         * @param {number} [page] Page of results to return.
         * @param {number} [limit] Limit of results to return.
         * @param {number} [minSeverity] Minimum fault severity filter.
         * @param {number} [maxSeverity] Maximum fault severity filter.
         * @param {number} [status] Fault status filter; 0: all unresolved (default), -1: all.
         * @param {number} [type] Fault type filter.
         * @param {number} [source] Fault source filter.
         * @param {string} [order] Ordering for the results; asc or desc.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResourceFaultSites: (resourceType, resourceId, page, limit, minSeverity, maxSeverity, status, type, source, order, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'resourceType' is not null or undefined
            assertParamExists('getResourceFaultSites', 'resourceType', resourceType);
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('getResourceFaultSites', 'resourceId', resourceId);
            const localVarPath = `/faults/resource/{resourceType}/{resourceId}/sites`
                .replace(`{${"resourceType"}}`, encodeURIComponent(String(resourceType)))
                .replace(`{${"resourceId"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (minSeverity !== undefined) {
                localVarQueryParameter['minSeverity'] = minSeverity;
            }
            if (maxSeverity !== undefined) {
                localVarQueryParameter['maxSeverity'] = maxSeverity;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} resourceType Type of the resource; schemas, organisations, sites, meters or solar(-)systems.
         * @param {number} resourceId ID of the resource.
         * @param {number} [page] Page of results to return.
         * @param {number} [limit] Limit of results to return.
         * @param {number} [minSeverity] Minimum fault severity filter.
         * @param {number} [maxSeverity] Maximum fault severity filter.
         * @param {number} [status] Fault status filter; 0: all unresolved (default), -1: all.
         * @param {number} [type] Fault type filter.
         * @param {number} [source] Fault source filter.
         * @param {string} [order] Ordering for the results; asc or desc.
         * @param {string} [orderBy] Column to order the results by; triggerTime, severity, siteName or created.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResourceFaults: (resourceType, resourceId, page, limit, minSeverity, maxSeverity, status, type, source, order, orderBy, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'resourceType' is not null or undefined
            assertParamExists('getResourceFaults', 'resourceType', resourceType);
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('getResourceFaults', 'resourceId', resourceId);
            const localVarPath = `/faults/resource/{resourceType}/{resourceId}`
                .replace(`{${"resourceType"}}`, encodeURIComponent(String(resourceType)))
                .replace(`{${"resourceId"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (minSeverity !== undefined) {
                localVarQueryParameter['minSeverity'] = minSeverity;
            }
            if (maxSeverity !== undefined) {
                localVarQueryParameter['maxSeverity'] = maxSeverity;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * FaultsApi - functional programming interface
 * @export
 */
export const FaultsApiFp = function (configuration) {
    const localVarAxiosParamCreator = FaultsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} resourceType Type of the resource; schemas, organisations, sites, meters or solar(-)systems.
         * @param {number} resourceId ID of the resource.
         * @param {number} [minSeverity] Minimum fault severity filter.
         * @param {number} [maxSeverity] Maximum fault severity filter.
         * @param {number} [status] Fault status filter; 0: all unresolved (default), -1: all.
         * @param {number} [type] Fault type filter.
         * @param {number} [source] Fault source filter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countResourceFaults(resourceType, resourceId, minSeverity, maxSeverity, status, type, source, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.countResourceFaults(resourceType, resourceId, minSeverity, maxSeverity, status, type, source, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {CreateFault} [createFault] Payload for creating a new fault.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createFault, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.create(createFault, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {CreateFaultLog} [createFaultLog] Payload for creating a new log for a fault.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFaultLog(id, createFaultLog, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createFaultLog(id, createFaultLog, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.get(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} resourceType Type of the resource; schemas, organisations or sites.
         * @param {number} resourceId ID of the resource.
         * @param {number} [page] Page of results to return.
         * @param {number} [limit] Limit of results to return.
         * @param {number} [minSeverity] Minimum fault severity filter.
         * @param {number} [maxSeverity] Maximum fault severity filter.
         * @param {number} [status] Fault status filter; 0: all unresolved (default), -1: all.
         * @param {number} [type] Fault type filter.
         * @param {number} [source] Fault source filter.
         * @param {string} [order] Ordering for the results; asc or desc.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResourceFaultSites(resourceType, resourceId, page, limit, minSeverity, maxSeverity, status, type, source, order, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getResourceFaultSites(resourceType, resourceId, page, limit, minSeverity, maxSeverity, status, type, source, order, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} resourceType Type of the resource; schemas, organisations, sites, meters or solar(-)systems.
         * @param {number} resourceId ID of the resource.
         * @param {number} [page] Page of results to return.
         * @param {number} [limit] Limit of results to return.
         * @param {number} [minSeverity] Minimum fault severity filter.
         * @param {number} [maxSeverity] Maximum fault severity filter.
         * @param {number} [status] Fault status filter; 0: all unresolved (default), -1: all.
         * @param {number} [type] Fault type filter.
         * @param {number} [source] Fault source filter.
         * @param {string} [order] Ordering for the results; asc or desc.
         * @param {string} [orderBy] Column to order the results by; triggerTime, severity, siteName or created.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResourceFaults(resourceType, resourceId, page, limit, minSeverity, maxSeverity, status, type, source, order, orderBy, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getResourceFaults(resourceType, resourceId, page, limit, minSeverity, maxSeverity, status, type, source, order, orderBy, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * FaultsApi - factory interface
 * @export
 */
export const FaultsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = FaultsApiFp(configuration);
    return {
        /**
         *
         * @param {string} resourceType Type of the resource; schemas, organisations, sites, meters or solar(-)systems.
         * @param {number} resourceId ID of the resource.
         * @param {number} [minSeverity] Minimum fault severity filter.
         * @param {number} [maxSeverity] Maximum fault severity filter.
         * @param {number} [status] Fault status filter; 0: all unresolved (default), -1: all.
         * @param {number} [type] Fault type filter.
         * @param {number} [source] Fault source filter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countResourceFaults(resourceType, resourceId, minSeverity, maxSeverity, status, type, source, options) {
            return localVarFp.countResourceFaults(resourceType, resourceId, minSeverity, maxSeverity, status, type, source, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateFault} [createFault] Payload for creating a new fault.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createFault, options) {
            return localVarFp.create(createFault, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {CreateFaultLog} [createFaultLog] Payload for creating a new log for a fault.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFaultLog(id, createFaultLog, options) {
            return localVarFp.createFaultLog(id, createFaultLog, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id, options) {
            return localVarFp.get(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} resourceType Type of the resource; schemas, organisations or sites.
         * @param {number} resourceId ID of the resource.
         * @param {number} [page] Page of results to return.
         * @param {number} [limit] Limit of results to return.
         * @param {number} [minSeverity] Minimum fault severity filter.
         * @param {number} [maxSeverity] Maximum fault severity filter.
         * @param {number} [status] Fault status filter; 0: all unresolved (default), -1: all.
         * @param {number} [type] Fault type filter.
         * @param {number} [source] Fault source filter.
         * @param {string} [order] Ordering for the results; asc or desc.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResourceFaultSites(resourceType, resourceId, page, limit, minSeverity, maxSeverity, status, type, source, order, options) {
            return localVarFp.getResourceFaultSites(resourceType, resourceId, page, limit, minSeverity, maxSeverity, status, type, source, order, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} resourceType Type of the resource; schemas, organisations, sites, meters or solar(-)systems.
         * @param {number} resourceId ID of the resource.
         * @param {number} [page] Page of results to return.
         * @param {number} [limit] Limit of results to return.
         * @param {number} [minSeverity] Minimum fault severity filter.
         * @param {number} [maxSeverity] Maximum fault severity filter.
         * @param {number} [status] Fault status filter; 0: all unresolved (default), -1: all.
         * @param {number} [type] Fault type filter.
         * @param {number} [source] Fault source filter.
         * @param {string} [order] Ordering for the results; asc or desc.
         * @param {string} [orderBy] Column to order the results by; triggerTime, severity, siteName or created.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResourceFaults(resourceType, resourceId, page, limit, minSeverity, maxSeverity, status, type, source, order, orderBy, options) {
            return localVarFp.getResourceFaults(resourceType, resourceId, page, limit, minSeverity, maxSeverity, status, type, source, order, orderBy, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * FaultsApi - object-oriented interface
 * @export
 * @class FaultsApi
 * @extends {BaseAPI}
 */
export class FaultsApi extends BaseAPI {
    /**
     *
     * @param {string} resourceType Type of the resource; schemas, organisations, sites, meters or solar(-)systems.
     * @param {number} resourceId ID of the resource.
     * @param {number} [minSeverity] Minimum fault severity filter.
     * @param {number} [maxSeverity] Maximum fault severity filter.
     * @param {number} [status] Fault status filter; 0: all unresolved (default), -1: all.
     * @param {number} [type] Fault type filter.
     * @param {number} [source] Fault source filter.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FaultsApi
     */
    countResourceFaults(resourceType, resourceId, minSeverity, maxSeverity, status, type, source, options) {
        return FaultsApiFp(this.configuration).countResourceFaults(resourceType, resourceId, minSeverity, maxSeverity, status, type, source, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CreateFault} [createFault] Payload for creating a new fault.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FaultsApi
     */
    create(createFault, options) {
        return FaultsApiFp(this.configuration).create(createFault, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {CreateFaultLog} [createFaultLog] Payload for creating a new log for a fault.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FaultsApi
     */
    createFaultLog(id, createFaultLog, options) {
        return FaultsApiFp(this.configuration).createFaultLog(id, createFaultLog, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FaultsApi
     */
    get(id, options) {
        return FaultsApiFp(this.configuration).get(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} resourceType Type of the resource; schemas, organisations or sites.
     * @param {number} resourceId ID of the resource.
     * @param {number} [page] Page of results to return.
     * @param {number} [limit] Limit of results to return.
     * @param {number} [minSeverity] Minimum fault severity filter.
     * @param {number} [maxSeverity] Maximum fault severity filter.
     * @param {number} [status] Fault status filter; 0: all unresolved (default), -1: all.
     * @param {number} [type] Fault type filter.
     * @param {number} [source] Fault source filter.
     * @param {string} [order] Ordering for the results; asc or desc.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FaultsApi
     */
    getResourceFaultSites(resourceType, resourceId, page, limit, minSeverity, maxSeverity, status, type, source, order, options) {
        return FaultsApiFp(this.configuration).getResourceFaultSites(resourceType, resourceId, page, limit, minSeverity, maxSeverity, status, type, source, order, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} resourceType Type of the resource; schemas, organisations, sites, meters or solar(-)systems.
     * @param {number} resourceId ID of the resource.
     * @param {number} [page] Page of results to return.
     * @param {number} [limit] Limit of results to return.
     * @param {number} [minSeverity] Minimum fault severity filter.
     * @param {number} [maxSeverity] Maximum fault severity filter.
     * @param {number} [status] Fault status filter; 0: all unresolved (default), -1: all.
     * @param {number} [type] Fault type filter.
     * @param {number} [source] Fault source filter.
     * @param {string} [order] Ordering for the results; asc or desc.
     * @param {string} [orderBy] Column to order the results by; triggerTime, severity, siteName or created.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FaultsApi
     */
    getResourceFaults(resourceType, resourceId, page, limit, minSeverity, maxSeverity, status, type, source, order, orderBy, options) {
        return FaultsApiFp(this.configuration).getResourceFaults(resourceType, resourceId, page, limit, minSeverity, maxSeverity, status, type, source, order, orderBy, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * MetersApi - axios parameter creator
 * @export
 */
export const MetersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('_delete', 'id', id);
            const localVarPath = `/meters/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CreateMeter} [createMeter] Payload for creating a new meter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: (createMeter, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/meters/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createMeter, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {boolean} [attachChannels] Attach channels to the meter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: (id, attachChannels, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('get', 'id', id);
            const localVarPath = `/meters/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            if (attachChannels !== undefined) {
                localVarQueryParameter['attachChannels'] = attachChannels;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {string} start The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone; 2018-12-03 or 2018-12-03 13:00:00 or 2018-12-03T13:00:00.
         * @param {string} [end] The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - format without a timezone; 2018-12-03 or 2018-12-03 13:00:00 or 2018-12-03T13:00:00.
         * @param {string} [timeContext] Search on universal or local time; universal or local.
         * @param {Array<string>} [fields] List of properties to return; energyPositive, energyPositiveCo2, energyReactivePositive, energyNegative, energyNegativeCo2, energyReactiveNegative, powerFactorPositive, powerFactorNegative, voltageRmsMin, voltageRmsMax, currentRmsMin or currentRmsMax.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChannelsDataFeed: (id, start, end, timeContext, fields, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getChannelsDataFeed', 'id', id);
            // verify required parameter 'start' is not null or undefined
            assertParamExists('getChannelsDataFeed', 'start', start);
            const localVarPath = `/meters/{id}/channels/data-feed`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            if (start !== undefined) {
                localVarQueryParameter['start'] = start;
            }
            if (end !== undefined) {
                localVarQueryParameter['end'] = end;
            }
            if (timeContext !== undefined) {
                localVarQueryParameter['timeContext'] = timeContext;
            }
            if (fields) {
                localVarQueryParameter['fields'] = fields;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestShortEnergy: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getLatestShortEnergy', 'id', id);
            const localVarPath = `/meters/{id}/energy/short/latest`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeterTypes: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/meters/types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} utilityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeterTypes_1: (utilityId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'utilityId' is not null or undefined
            assertParamExists('getMeterTypes_1', 'utilityId', utilityId);
            const localVarPath = `/meters/utilities/{utilityId}/types`
                .replace(`{${"utilityId"}}`, encodeURIComponent(String(utilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {string} [start] The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
         * @param {string} [end] The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - format without a timezone.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShortEnergy: (id, start, end, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getShortEnergy', 'id', id);
            const localVarPath = `/meters/{id}/energy/short`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            if (start !== undefined) {
                localVarQueryParameter['start'] = start;
            }
            if (end !== undefined) {
                localVarQueryParameter['end'] = end;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} deviceId ID of the Wattwatchers device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWattwatchersDevice: (deviceId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('getWattwatchersDevice', 'deviceId', deviceId);
            const localVarPath = `/meters/wattwatchers/device/{deviceId}`
                .replace(`{${"deviceId"}}`, encodeURIComponent(String(deviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUtilities: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/meters/utilities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {SetChannels} [setChannels] Payload for setting channels for a meter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setChannels: (id, setChannels, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('setChannels', 'id', id);
            const localVarPath = `/meters/{id}/channels`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(setChannels, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {SetImportTime} [setImportTime] Payload for setting the import time for a meter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setImportTime: (id, setImportTime, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('setImportTime', 'id', id);
            const localVarPath = `/meters/{id}/import/time`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(setImportTime, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {UpdateMeter} [updateMeter] Payload for updating a new meter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: (id, updateMeter, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id);
            const localVarPath = `/meters/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateMeter, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {UpdateWattwatchersDevice} [updateWattwatchersDevice] Payload for updating a Wattwatchers device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWattwatchersDevice: (id, updateWattwatchersDevice, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateWattwatchersDevice', 'id', id);
            const localVarPath = `/meters/{id}/wattwatchers/device`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateWattwatchersDevice, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * MetersApi - functional programming interface
 * @export
 */
export const MetersApiFp = function (configuration) {
    const localVarAxiosParamCreator = MetersApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator._delete(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {CreateMeter} [createMeter] Payload for creating a new meter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createMeter, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.create(createMeter, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {boolean} [attachChannels] Attach channels to the meter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id, attachChannels, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.get(id, attachChannels, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {string} start The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone; 2018-12-03 or 2018-12-03 13:00:00 or 2018-12-03T13:00:00.
         * @param {string} [end] The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - format without a timezone; 2018-12-03 or 2018-12-03 13:00:00 or 2018-12-03T13:00:00.
         * @param {string} [timeContext] Search on universal or local time; universal or local.
         * @param {Array<string>} [fields] List of properties to return; energyPositive, energyPositiveCo2, energyReactivePositive, energyNegative, energyNegativeCo2, energyReactiveNegative, powerFactorPositive, powerFactorNegative, voltageRmsMin, voltageRmsMax, currentRmsMin or currentRmsMax.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChannelsDataFeed(id, start, end, timeContext, fields, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getChannelsDataFeed(id, start, end, timeContext, fields, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestShortEnergy(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getLatestShortEnergy(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeterTypes(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMeterTypes(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} utilityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeterTypes_1(utilityId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMeterTypes_1(utilityId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {string} [start] The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
         * @param {string} [end] The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - format without a timezone.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShortEnergy(id, start, end, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getShortEnergy(id, start, end, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} deviceId ID of the Wattwatchers device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWattwatchersDevice(deviceId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getWattwatchersDevice(deviceId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUtilities(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listUtilities(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {SetChannels} [setChannels] Payload for setting channels for a meter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setChannels(id, setChannels, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.setChannels(id, setChannels, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {SetImportTime} [setImportTime] Payload for setting the import time for a meter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setImportTime(id, setImportTime, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.setImportTime(id, setImportTime, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {UpdateMeter} [updateMeter] Payload for updating a new meter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id, updateMeter, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.update(id, updateMeter, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {UpdateWattwatchersDevice} [updateWattwatchersDevice] Payload for updating a Wattwatchers device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWattwatchersDevice(id, updateWattwatchersDevice, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateWattwatchersDevice(id, updateWattwatchersDevice, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * MetersApi - factory interface
 * @export
 */
export const MetersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = MetersApiFp(configuration);
    return {
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(id, options) {
            return localVarFp._delete(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateMeter} [createMeter] Payload for creating a new meter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createMeter, options) {
            return localVarFp.create(createMeter, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {boolean} [attachChannels] Attach channels to the meter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id, attachChannels, options) {
            return localVarFp.get(id, attachChannels, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {string} start The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone; 2018-12-03 or 2018-12-03 13:00:00 or 2018-12-03T13:00:00.
         * @param {string} [end] The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - format without a timezone; 2018-12-03 or 2018-12-03 13:00:00 or 2018-12-03T13:00:00.
         * @param {string} [timeContext] Search on universal or local time; universal or local.
         * @param {Array<string>} [fields] List of properties to return; energyPositive, energyPositiveCo2, energyReactivePositive, energyNegative, energyNegativeCo2, energyReactiveNegative, powerFactorPositive, powerFactorNegative, voltageRmsMin, voltageRmsMax, currentRmsMin or currentRmsMax.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChannelsDataFeed(id, start, end, timeContext, fields, options) {
            return localVarFp.getChannelsDataFeed(id, start, end, timeContext, fields, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestShortEnergy(id, options) {
            return localVarFp.getLatestShortEnergy(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeterTypes(options) {
            return localVarFp.getMeterTypes(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} utilityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeterTypes_1(utilityId, options) {
            return localVarFp.getMeterTypes_1(utilityId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {string} [start] The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
         * @param {string} [end] The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - format without a timezone.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShortEnergy(id, start, end, options) {
            return localVarFp.getShortEnergy(id, start, end, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} deviceId ID of the Wattwatchers device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWattwatchersDevice(deviceId, options) {
            return localVarFp.getWattwatchersDevice(deviceId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUtilities(options) {
            return localVarFp.listUtilities(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {SetChannels} [setChannels] Payload for setting channels for a meter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setChannels(id, setChannels, options) {
            return localVarFp.setChannels(id, setChannels, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {SetImportTime} [setImportTime] Payload for setting the import time for a meter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setImportTime(id, setImportTime, options) {
            return localVarFp.setImportTime(id, setImportTime, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {UpdateMeter} [updateMeter] Payload for updating a new meter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id, updateMeter, options) {
            return localVarFp.update(id, updateMeter, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {UpdateWattwatchersDevice} [updateWattwatchersDevice] Payload for updating a Wattwatchers device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWattwatchersDevice(id, updateWattwatchersDevice, options) {
            return localVarFp.updateWattwatchersDevice(id, updateWattwatchersDevice, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * MetersApi - object-oriented interface
 * @export
 * @class MetersApi
 * @extends {BaseAPI}
 */
export class MetersApi extends BaseAPI {
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetersApi
     */
    _delete(id, options) {
        return MetersApiFp(this.configuration)._delete(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CreateMeter} [createMeter] Payload for creating a new meter.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetersApi
     */
    create(createMeter, options) {
        return MetersApiFp(this.configuration).create(createMeter, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {boolean} [attachChannels] Attach channels to the meter.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetersApi
     */
    get(id, attachChannels, options) {
        return MetersApiFp(this.configuration).get(id, attachChannels, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {string} start The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone; 2018-12-03 or 2018-12-03 13:00:00 or 2018-12-03T13:00:00.
     * @param {string} [end] The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - format without a timezone; 2018-12-03 or 2018-12-03 13:00:00 or 2018-12-03T13:00:00.
     * @param {string} [timeContext] Search on universal or local time; universal or local.
     * @param {Array<string>} [fields] List of properties to return; energyPositive, energyPositiveCo2, energyReactivePositive, energyNegative, energyNegativeCo2, energyReactiveNegative, powerFactorPositive, powerFactorNegative, voltageRmsMin, voltageRmsMax, currentRmsMin or currentRmsMax.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetersApi
     */
    getChannelsDataFeed(id, start, end, timeContext, fields, options) {
        return MetersApiFp(this.configuration).getChannelsDataFeed(id, start, end, timeContext, fields, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetersApi
     */
    getLatestShortEnergy(id, options) {
        return MetersApiFp(this.configuration).getLatestShortEnergy(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetersApi
     */
    getMeterTypes(options) {
        return MetersApiFp(this.configuration).getMeterTypes(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} utilityId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetersApi
     */
    getMeterTypes_1(utilityId, options) {
        return MetersApiFp(this.configuration).getMeterTypes_1(utilityId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {string} [start] The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
     * @param {string} [end] The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - format without a timezone.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetersApi
     */
    getShortEnergy(id, start, end, options) {
        return MetersApiFp(this.configuration).getShortEnergy(id, start, end, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} deviceId ID of the Wattwatchers device.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetersApi
     */
    getWattwatchersDevice(deviceId, options) {
        return MetersApiFp(this.configuration).getWattwatchersDevice(deviceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetersApi
     */
    listUtilities(options) {
        return MetersApiFp(this.configuration).listUtilities(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {SetChannels} [setChannels] Payload for setting channels for a meter.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetersApi
     */
    setChannels(id, setChannels, options) {
        return MetersApiFp(this.configuration).setChannels(id, setChannels, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {SetImportTime} [setImportTime] Payload for setting the import time for a meter.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetersApi
     */
    setImportTime(id, setImportTime, options) {
        return MetersApiFp(this.configuration).setImportTime(id, setImportTime, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {UpdateMeter} [updateMeter] Payload for updating a new meter.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetersApi
     */
    update(id, updateMeter, options) {
        return MetersApiFp(this.configuration).update(id, updateMeter, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {UpdateWattwatchersDevice} [updateWattwatchersDevice] Payload for updating a Wattwatchers device.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetersApi
     */
    updateWattwatchersDevice(id, updateWattwatchersDevice, options) {
        return MetersApiFp(this.configuration).updateWattwatchersDevice(id, updateWattwatchersDevice, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * OrganisationsApi - axios parameter creator
 * @export
 */
export const OrganisationsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CreateOrganisation} [createOrganisation] Payload for creating an organisation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: (createOrganisation, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/organisations/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createOrganisation, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('get', 'id', id);
            const localVarPath = `/organisations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {string} [filter] Filter for the name of the site.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMapSites: (id, filter, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getMapSites', 'id', id);
            const localVarPath = `/organisations/{id}/sites/map`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchemas: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSchemas', 'id', id);
            const localVarPath = `/organisations/{id}/schemas`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSiteCustomAttributes: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSiteCustomAttributes', 'id', id);
            const localVarPath = `/organisations/{id}/sites/attributes`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {number} [page] Page of results to return.
         * @param {number} [limit] Limit of results to return.
         * @param {string} [filter] Filter for the organisation name of the site.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSites: (id, page, limit, filter, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSites', 'id', id);
            const localVarPath = `/organisations/{id}/sites`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {string} [timezone] Users IANA timezone.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSitesSolarReport: (id, timezone, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSitesSolarReport', 'id', id);
            const localVarPath = `/organisations/{id}/reports/sites-solar`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            if (timezone !== undefined) {
                localVarQueryParameter['timezone'] = timezone;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSolarCurrentStats: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSolarCurrentStats', 'id', id);
            const localVarPath = `/organisations/{id}/solar/stats/current`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {string} [timezone] User\&#39;s IANA timezone.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSummary: (id, timezone, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSummary', 'id', id);
            const localVarPath = `/organisations/{id}/summary`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            // authentication ApiSoftAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (timezone !== undefined) {
                localVarQueryParameter['timezone'] = timezone;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {string} name Name of the site to test.
         * @param {string} [slug] Slug of the site to test.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testSiteName: (id, name, slug, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('testSiteName', 'id', id);
            // verify required parameter 'name' is not null or undefined
            assertParamExists('testSiteName', 'name', name);
            const localVarPath = `/organisations/{id}/sites/test-name`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {UpdateOrganisation} [updateOrganisation] Payload for updating an organisation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: (id, updateOrganisation, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id);
            const localVarPath = `/organisations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateOrganisation, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {Array<number>} [requestBody] Payload for updating an organisations schemas.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSchemas: (id, requestBody, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateSchemas', 'id', id);
            const localVarPath = `/organisations/{id}/schemas`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * OrganisationsApi - functional programming interface
 * @export
 */
export const OrganisationsApiFp = function (configuration) {
    const localVarAxiosParamCreator = OrganisationsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {CreateOrganisation} [createOrganisation] Payload for creating an organisation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createOrganisation, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.create(createOrganisation, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.get(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {string} [filter] Filter for the name of the site.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMapSites(id, filter, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMapSites(id, filter, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchemas(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSchemas(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSiteCustomAttributes(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSiteCustomAttributes(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {number} [page] Page of results to return.
         * @param {number} [limit] Limit of results to return.
         * @param {string} [filter] Filter for the organisation name of the site.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSites(id, page, limit, filter, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSites(id, page, limit, filter, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {string} [timezone] Users IANA timezone.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSitesSolarReport(id, timezone, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSitesSolarReport(id, timezone, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSolarCurrentStats(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSolarCurrentStats(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {string} [timezone] User\&#39;s IANA timezone.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSummary(id, timezone, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSummary(id, timezone, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {string} name Name of the site to test.
         * @param {string} [slug] Slug of the site to test.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testSiteName(id, name, slug, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.testSiteName(id, name, slug, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {UpdateOrganisation} [updateOrganisation] Payload for updating an organisation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id, updateOrganisation, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.update(id, updateOrganisation, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {Array<number>} [requestBody] Payload for updating an organisations schemas.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSchemas(id, requestBody, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateSchemas(id, requestBody, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * OrganisationsApi - factory interface
 * @export
 */
export const OrganisationsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = OrganisationsApiFp(configuration);
    return {
        /**
         *
         * @param {CreateOrganisation} [createOrganisation] Payload for creating an organisation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createOrganisation, options) {
            return localVarFp.create(createOrganisation, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id, options) {
            return localVarFp.get(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {string} [filter] Filter for the name of the site.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMapSites(id, filter, options) {
            return localVarFp.getMapSites(id, filter, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchemas(id, options) {
            return localVarFp.getSchemas(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSiteCustomAttributes(id, options) {
            return localVarFp.getSiteCustomAttributes(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {number} [page] Page of results to return.
         * @param {number} [limit] Limit of results to return.
         * @param {string} [filter] Filter for the organisation name of the site.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSites(id, page, limit, filter, options) {
            return localVarFp.getSites(id, page, limit, filter, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {string} [timezone] Users IANA timezone.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSitesSolarReport(id, timezone, options) {
            return localVarFp.getSitesSolarReport(id, timezone, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSolarCurrentStats(id, options) {
            return localVarFp.getSolarCurrentStats(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {string} [timezone] User\&#39;s IANA timezone.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSummary(id, timezone, options) {
            return localVarFp.getSummary(id, timezone, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {string} name Name of the site to test.
         * @param {string} [slug] Slug of the site to test.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testSiteName(id, name, slug, options) {
            return localVarFp.testSiteName(id, name, slug, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {UpdateOrganisation} [updateOrganisation] Payload for updating an organisation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id, updateOrganisation, options) {
            return localVarFp.update(id, updateOrganisation, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {Array<number>} [requestBody] Payload for updating an organisations schemas.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSchemas(id, requestBody, options) {
            return localVarFp.updateSchemas(id, requestBody, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * OrganisationsApi - object-oriented interface
 * @export
 * @class OrganisationsApi
 * @extends {BaseAPI}
 */
export class OrganisationsApi extends BaseAPI {
    /**
     *
     * @param {CreateOrganisation} [createOrganisation] Payload for creating an organisation.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationsApi
     */
    create(createOrganisation, options) {
        return OrganisationsApiFp(this.configuration).create(createOrganisation, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationsApi
     */
    get(id, options) {
        return OrganisationsApiFp(this.configuration).get(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {string} [filter] Filter for the name of the site.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationsApi
     */
    getMapSites(id, filter, options) {
        return OrganisationsApiFp(this.configuration).getMapSites(id, filter, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationsApi
     */
    getSchemas(id, options) {
        return OrganisationsApiFp(this.configuration).getSchemas(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationsApi
     */
    getSiteCustomAttributes(id, options) {
        return OrganisationsApiFp(this.configuration).getSiteCustomAttributes(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {number} [page] Page of results to return.
     * @param {number} [limit] Limit of results to return.
     * @param {string} [filter] Filter for the organisation name of the site.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationsApi
     */
    getSites(id, page, limit, filter, options) {
        return OrganisationsApiFp(this.configuration).getSites(id, page, limit, filter, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {string} [timezone] Users IANA timezone.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationsApi
     */
    getSitesSolarReport(id, timezone, options) {
        return OrganisationsApiFp(this.configuration).getSitesSolarReport(id, timezone, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationsApi
     */
    getSolarCurrentStats(id, options) {
        return OrganisationsApiFp(this.configuration).getSolarCurrentStats(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {string} [timezone] User\&#39;s IANA timezone.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationsApi
     */
    getSummary(id, timezone, options) {
        return OrganisationsApiFp(this.configuration).getSummary(id, timezone, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {string} name Name of the site to test.
     * @param {string} [slug] Slug of the site to test.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationsApi
     */
    testSiteName(id, name, slug, options) {
        return OrganisationsApiFp(this.configuration).testSiteName(id, name, slug, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {UpdateOrganisation} [updateOrganisation] Payload for updating an organisation.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationsApi
     */
    update(id, updateOrganisation, options) {
        return OrganisationsApiFp(this.configuration).update(id, updateOrganisation, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {Array<number>} [requestBody] Payload for updating an organisations schemas.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationsApi
     */
    updateSchemas(id, requestBody, options) {
        return OrganisationsApiFp(this.configuration).updateSchemas(id, requestBody, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * PlanetWatchApi - axios parameter creator
 * @export
 */
export const PlanetWatchApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGlobalConfig: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/planet-watch/config/global`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [mode] Mode for the leaderboard. Valid values are: selective, contextual, state, national or default.
         * @param {number} [id] ID of the planet for a contextual leaderboard.
         * @param {Array<number>} [ids] List of planet IDs for a selective leaderboard.
         * @param {number} [page] Page of results to return. Defaults to 1.
         * @param {number} [limit] Maximum number of results to return. Defaults to 10.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeaderboard: (mode, id, ids, page, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/planet-watch/leaderboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (mode !== undefined) {
                localVarQueryParameter['mode'] = mode;
            }
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} longitude Longitude start point.
         * @param {number} latitude Latitude start point.
         * @param {number} [page] Page of results to return. Defaults to 1.
         * @param {number} [limit] Maximum number of results to return. Defaults to 10.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNearbyPlanets: (longitude, latitude, page, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'longitude' is not null or undefined
            assertParamExists('getNearbyPlanets', 'longitude', longitude);
            // verify required parameter 'latitude' is not null or undefined
            assertParamExists('getNearbyPlanets', 'latitude', latitude);
            const localVarPath = `/planet-watch/planets/nearby`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (longitude !== undefined) {
                localVarQueryParameter['longitude'] = longitude;
            }
            if (latitude !== undefined) {
                localVarQueryParameter['latitude'] = latitude;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanetDailyAverageConsumption: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPlanetDailyAverageConsumption', 'id', id);
            const localVarPath = `/planet-watch/planets/{id}/daily-average-consumption`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [mode] Mode context of the data. Valid values are: live or regular.
         * @param {Array<number>} [ids] List of planet IDs to get info for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanets: (mode, ids, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/planet-watch/planets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (mode !== undefined) {
                localVarQueryParameter['mode'] = mode;
            }
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUniverseNode: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getUniverseNode', 'id', id);
            const localVarPath = `/planet-watch/universe/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} term Name search term.
         * @param {number} [page] Page of results to return. Defaults to 1.
         * @param {number} [limit] Maximum number of results to return. Defaults to 10.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPlanets: (term, page, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'term' is not null or undefined
            assertParamExists('searchPlanets', 'term', term);
            const localVarPath = `/planet-watch/planets/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * PlanetWatchApi - functional programming interface
 * @export
 */
export const PlanetWatchApiFp = function (configuration) {
    const localVarAxiosParamCreator = PlanetWatchApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGlobalConfig(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getGlobalConfig(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} [mode] Mode for the leaderboard. Valid values are: selective, contextual, state, national or default.
         * @param {number} [id] ID of the planet for a contextual leaderboard.
         * @param {Array<number>} [ids] List of planet IDs for a selective leaderboard.
         * @param {number} [page] Page of results to return. Defaults to 1.
         * @param {number} [limit] Maximum number of results to return. Defaults to 10.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeaderboard(mode, id, ids, page, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getLeaderboard(mode, id, ids, page, limit, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} longitude Longitude start point.
         * @param {number} latitude Latitude start point.
         * @param {number} [page] Page of results to return. Defaults to 1.
         * @param {number} [limit] Maximum number of results to return. Defaults to 10.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNearbyPlanets(longitude, latitude, page, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getNearbyPlanets(longitude, latitude, page, limit, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanetDailyAverageConsumption(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPlanetDailyAverageConsumption(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} [mode] Mode context of the data. Valid values are: live or regular.
         * @param {Array<number>} [ids] List of planet IDs to get info for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanets(mode, ids, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPlanets(mode, ids, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUniverseNode(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUniverseNode(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} term Name search term.
         * @param {number} [page] Page of results to return. Defaults to 1.
         * @param {number} [limit] Maximum number of results to return. Defaults to 10.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPlanets(term, page, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchPlanets(term, page, limit, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * PlanetWatchApi - factory interface
 * @export
 */
export const PlanetWatchApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PlanetWatchApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGlobalConfig(options) {
            return localVarFp.getGlobalConfig(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [mode] Mode for the leaderboard. Valid values are: selective, contextual, state, national or default.
         * @param {number} [id] ID of the planet for a contextual leaderboard.
         * @param {Array<number>} [ids] List of planet IDs for a selective leaderboard.
         * @param {number} [page] Page of results to return. Defaults to 1.
         * @param {number} [limit] Maximum number of results to return. Defaults to 10.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeaderboard(mode, id, ids, page, limit, options) {
            return localVarFp.getLeaderboard(mode, id, ids, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} longitude Longitude start point.
         * @param {number} latitude Latitude start point.
         * @param {number} [page] Page of results to return. Defaults to 1.
         * @param {number} [limit] Maximum number of results to return. Defaults to 10.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNearbyPlanets(longitude, latitude, page, limit, options) {
            return localVarFp.getNearbyPlanets(longitude, latitude, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanetDailyAverageConsumption(id, options) {
            return localVarFp.getPlanetDailyAverageConsumption(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [mode] Mode context of the data. Valid values are: live or regular.
         * @param {Array<number>} [ids] List of planet IDs to get info for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanets(mode, ids, options) {
            return localVarFp.getPlanets(mode, ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUniverseNode(id, options) {
            return localVarFp.getUniverseNode(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} term Name search term.
         * @param {number} [page] Page of results to return. Defaults to 1.
         * @param {number} [limit] Maximum number of results to return. Defaults to 10.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPlanets(term, page, limit, options) {
            return localVarFp.searchPlanets(term, page, limit, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PlanetWatchApi - object-oriented interface
 * @export
 * @class PlanetWatchApi
 * @extends {BaseAPI}
 */
export class PlanetWatchApi extends BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlanetWatchApi
     */
    getGlobalConfig(options) {
        return PlanetWatchApiFp(this.configuration).getGlobalConfig(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [mode] Mode for the leaderboard. Valid values are: selective, contextual, state, national or default.
     * @param {number} [id] ID of the planet for a contextual leaderboard.
     * @param {Array<number>} [ids] List of planet IDs for a selective leaderboard.
     * @param {number} [page] Page of results to return. Defaults to 1.
     * @param {number} [limit] Maximum number of results to return. Defaults to 10.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlanetWatchApi
     */
    getLeaderboard(mode, id, ids, page, limit, options) {
        return PlanetWatchApiFp(this.configuration).getLeaderboard(mode, id, ids, page, limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} longitude Longitude start point.
     * @param {number} latitude Latitude start point.
     * @param {number} [page] Page of results to return. Defaults to 1.
     * @param {number} [limit] Maximum number of results to return. Defaults to 10.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlanetWatchApi
     */
    getNearbyPlanets(longitude, latitude, page, limit, options) {
        return PlanetWatchApiFp(this.configuration).getNearbyPlanets(longitude, latitude, page, limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlanetWatchApi
     */
    getPlanetDailyAverageConsumption(id, options) {
        return PlanetWatchApiFp(this.configuration).getPlanetDailyAverageConsumption(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [mode] Mode context of the data. Valid values are: live or regular.
     * @param {Array<number>} [ids] List of planet IDs to get info for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlanetWatchApi
     */
    getPlanets(mode, ids, options) {
        return PlanetWatchApiFp(this.configuration).getPlanets(mode, ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlanetWatchApi
     */
    getUniverseNode(id, options) {
        return PlanetWatchApiFp(this.configuration).getUniverseNode(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} term Name search term.
     * @param {number} [page] Page of results to return. Defaults to 1.
     * @param {number} [limit] Maximum number of results to return. Defaults to 10.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlanetWatchApi
     */
    searchPlanets(term, page, limit, options) {
        return PlanetWatchApiFp(this.configuration).searchPlanets(term, page, limit, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * RemindersApi - axios parameter creator
 * @export
 */
export const RemindersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CreateReminder} [createReminder] Payload for creating a new reminder.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: (createReminder, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/reminders/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createReminder, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('get', 'id', id);
            const localVarPath = `/reminders/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [page] Page of results to return.
         * @param {number} [limit] Limit of results to return.
         * @param {string} [orderBy] Ordering of the result set; reminderTime, siteName, userName, id or created
         * @param {string} [order] Direction of the ordering; asc or desc - defaults to desc.
         * @param {string} [start] The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
         * @param {string} [end] The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - format without a timezone.
         * @param {number} [creatorId] ID of the creator user to filter by.
         * @param {number} [userId] ID of the subject user to filter by.
         * @param {number} [contactId] ID of the contact user to filter by.
         * @param {number} [siteId] ID of a site to filter by.
         * @param {number} [faultId] ID of a fault to filter by.
         * @param {Array<number>} [statuses] List of statuses to filter by.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search: (page, limit, orderBy, order, start, end, creatorId, userId, contactId, siteId, faultId, statuses, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/reminders/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (start !== undefined) {
                localVarQueryParameter['start'] = start;
            }
            if (end !== undefined) {
                localVarQueryParameter['end'] = end;
            }
            if (creatorId !== undefined) {
                localVarQueryParameter['creatorId'] = creatorId;
            }
            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }
            if (contactId !== undefined) {
                localVarQueryParameter['contactId'] = contactId;
            }
            if (siteId !== undefined) {
                localVarQueryParameter['siteId'] = siteId;
            }
            if (faultId !== undefined) {
                localVarQueryParameter['faultId'] = faultId;
            }
            if (statuses) {
                localVarQueryParameter['statuses'] = statuses;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {UpdateReminder} [updateReminder] Payload for updating an existing reminder.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: (id, updateReminder, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id);
            const localVarPath = `/reminders/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateReminder, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * RemindersApi - functional programming interface
 * @export
 */
export const RemindersApiFp = function (configuration) {
    const localVarAxiosParamCreator = RemindersApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {CreateReminder} [createReminder] Payload for creating a new reminder.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createReminder, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.create(createReminder, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.get(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} [page] Page of results to return.
         * @param {number} [limit] Limit of results to return.
         * @param {string} [orderBy] Ordering of the result set; reminderTime, siteName, userName, id or created
         * @param {string} [order] Direction of the ordering; asc or desc - defaults to desc.
         * @param {string} [start] The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
         * @param {string} [end] The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - format without a timezone.
         * @param {number} [creatorId] ID of the creator user to filter by.
         * @param {number} [userId] ID of the subject user to filter by.
         * @param {number} [contactId] ID of the contact user to filter by.
         * @param {number} [siteId] ID of a site to filter by.
         * @param {number} [faultId] ID of a fault to filter by.
         * @param {Array<number>} [statuses] List of statuses to filter by.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search(page, limit, orderBy, order, start, end, creatorId, userId, contactId, siteId, faultId, statuses, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.search(page, limit, orderBy, order, start, end, creatorId, userId, contactId, siteId, faultId, statuses, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {UpdateReminder} [updateReminder] Payload for updating an existing reminder.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id, updateReminder, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.update(id, updateReminder, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * RemindersApi - factory interface
 * @export
 */
export const RemindersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = RemindersApiFp(configuration);
    return {
        /**
         *
         * @param {CreateReminder} [createReminder] Payload for creating a new reminder.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createReminder, options) {
            return localVarFp.create(createReminder, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id, options) {
            return localVarFp.get(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Page of results to return.
         * @param {number} [limit] Limit of results to return.
         * @param {string} [orderBy] Ordering of the result set; reminderTime, siteName, userName, id or created
         * @param {string} [order] Direction of the ordering; asc or desc - defaults to desc.
         * @param {string} [start] The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
         * @param {string} [end] The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - format without a timezone.
         * @param {number} [creatorId] ID of the creator user to filter by.
         * @param {number} [userId] ID of the subject user to filter by.
         * @param {number} [contactId] ID of the contact user to filter by.
         * @param {number} [siteId] ID of a site to filter by.
         * @param {number} [faultId] ID of a fault to filter by.
         * @param {Array<number>} [statuses] List of statuses to filter by.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search(page, limit, orderBy, order, start, end, creatorId, userId, contactId, siteId, faultId, statuses, options) {
            return localVarFp.search(page, limit, orderBy, order, start, end, creatorId, userId, contactId, siteId, faultId, statuses, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {UpdateReminder} [updateReminder] Payload for updating an existing reminder.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id, updateReminder, options) {
            return localVarFp.update(id, updateReminder, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * RemindersApi - object-oriented interface
 * @export
 * @class RemindersApi
 * @extends {BaseAPI}
 */
export class RemindersApi extends BaseAPI {
    /**
     *
     * @param {CreateReminder} [createReminder] Payload for creating a new reminder.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RemindersApi
     */
    create(createReminder, options) {
        return RemindersApiFp(this.configuration).create(createReminder, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RemindersApi
     */
    get(id, options) {
        return RemindersApiFp(this.configuration).get(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Page of results to return.
     * @param {number} [limit] Limit of results to return.
     * @param {string} [orderBy] Ordering of the result set; reminderTime, siteName, userName, id or created
     * @param {string} [order] Direction of the ordering; asc or desc - defaults to desc.
     * @param {string} [start] The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
     * @param {string} [end] The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - format without a timezone.
     * @param {number} [creatorId] ID of the creator user to filter by.
     * @param {number} [userId] ID of the subject user to filter by.
     * @param {number} [contactId] ID of the contact user to filter by.
     * @param {number} [siteId] ID of a site to filter by.
     * @param {number} [faultId] ID of a fault to filter by.
     * @param {Array<number>} [statuses] List of statuses to filter by.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RemindersApi
     */
    search(page, limit, orderBy, order, start, end, creatorId, userId, contactId, siteId, faultId, statuses, options) {
        return RemindersApiFp(this.configuration).search(page, limit, orderBy, order, start, end, creatorId, userId, contactId, siteId, faultId, statuses, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {UpdateReminder} [updateReminder] Payload for updating an existing reminder.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RemindersApi
     */
    update(id, updateReminder, options) {
        return RemindersApiFp(this.configuration).update(id, updateReminder, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * SchemasApi - axios parameter creator
 * @export
 */
export const SchemasApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CreateSchema} [createSchema] Payload for creating a new schema.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: (createSchema, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/schemas/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createSchema, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('get', 'id', id);
            const localVarPath = `/schemas/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {number} [page] Page of results to return.
         * @param {number} [limit] Limit of results to return.
         * @param {number} [status] Filter results by status.
         * @param {string} [name] Filter results by name.
         * @param {string} [email] Filter results by email.
         * @param {string} [state] Filter results by state.
         * @param {string} [country] Filter results by country.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContractors: (id, page, limit, status, name, email, state, country, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getContractors', 'id', id);
            const localVarPath = `/schemas/{id}/contractors`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }
            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }
            if (country !== undefined) {
                localVarQueryParameter['country'] = country;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnergyBreakdown: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getEnergyBreakdown', 'id', id);
            const localVarPath = `/schemas/{id}/energy-breakdown`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {string} start The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
         * @param {string} [end] The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - format without a timezone.
         * @param {string} [aggregation] Suggested aggregation of the data. Is not guaranteed if date range is too large for the aggregation type.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnergyDataFeed: (id, start, end, aggregation, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getEnergyDataFeed', 'id', id);
            // verify required parameter 'start' is not null or undefined
            assertParamExists('getEnergyDataFeed', 'start', start);
            const localVarPath = `/schemas/{id}/energy/data-feed`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (start !== undefined) {
                localVarQueryParameter['start'] = start;
            }
            if (end !== undefined) {
                localVarQueryParameter['end'] = end;
            }
            if (aggregation !== undefined) {
                localVarQueryParameter['aggregation'] = aggregation;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {string} [timezone] Users IANA timezone.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnergyLifetimeSummary: (id, timezone, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getEnergyLifetimeSummary', 'id', id);
            const localVarPath = `/schemas/{id}/energy/summary/lifetime`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (timezone !== undefined) {
                localVarQueryParameter['timezone'] = timezone;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [type] Type filter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getList: (type, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/schemas/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {string} [filter] Filter for the name of the site.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMapSites: (id, filter, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getMapSites', 'id', id);
            const localVarPath = `/schemas/{id}/sites/map`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {string} slug Slug of the resource.
         * @param {string} [timezone] IANA timezone of the caller to determine the contextual current day. Defaults to Australia/Brisbane; e.g.: Australia/Brisbane
         * @param {boolean} [weather] Attach weather if it is a site resource.
         * @param {boolean} [summary] Attach summary if it is a site resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResourceBySlug: (id, slug, timezone, weather, summary, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getResourceBySlug', 'id', id);
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('getResourceBySlug', 'slug', slug);
            const localVarPath = `/schemas/{id}/resources/{slug}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (timezone !== undefined) {
                localVarQueryParameter['timezone'] = timezone;
            }
            if (weather !== undefined) {
                localVarQueryParameter['weather'] = weather;
            }
            if (summary !== undefined) {
                localVarQueryParameter['summary'] = summary;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} resourceType Resource type; e.g.: organisations or sites.
         * @param {Array<number>} ids List of schema IDs.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResourceTypeCustomAttributes: (resourceType, ids, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'resourceType' is not null or undefined
            assertParamExists('getResourceTypeCustomAttributes', 'resourceType', resourceType);
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('getResourceTypeCustomAttributes', 'ids', ids);
            const localVarPath = `/schemas/attributes/resource-types/{resourceType}`
                .replace(`{${"resourceType"}}`, encodeURIComponent(String(resourceType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {string} [timezone] IANA timezone of the caller to determine the contextual current day. Defaults to Australia/Brisbane.
         * @param {number} [phase] Installation phase of the program.
         * @param {number} [days] Number of days to analyse. Defaults to 28.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSavingsGuaranteeFeed: (id, timezone, phase, days, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSavingsGuaranteeFeed', 'id', id);
            const localVarPath = `/schemas/{id}/savings-guarantee/feed`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            if (timezone !== undefined) {
                localVarQueryParameter['timezone'] = timezone;
            }
            if (phase !== undefined) {
                localVarQueryParameter['phase'] = phase;
            }
            if (days !== undefined) {
                localVarQueryParameter['days'] = days;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {string} [timezone] IANA timezone of the caller to determine the contextual current day. Defaults to Australia/Brisbane.
         * @param {number} [phase] Installation phase of the program.
         * @param {number} [days] Number of days to analyse. Defaults to 28.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSavingsGuaranteeSummary: (id, timezone, phase, days, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSavingsGuaranteeSummary', 'id', id);
            const localVarPath = `/schemas/{id}/savings-guarantee/summary`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            if (timezone !== undefined) {
                localVarQueryParameter['timezone'] = timezone;
            }
            if (phase !== undefined) {
                localVarQueryParameter['phase'] = phase;
            }
            if (days !== undefined) {
                localVarQueryParameter['days'] = days;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {number} [page] Page of results to return.
         * @param {number} [limit] Limit of results to return.
         * @param {string} [filter] Filter for the organisation name of the site.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSites: (id, page, limit, filter, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSites', 'id', id);
            const localVarPath = `/schemas/{id}/sites`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {number} [phase] Installation phase to filter by.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSitesSolarReport: (id, phase, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSitesSolarReport', 'id', id);
            const localVarPath = `/schemas/{id}/reports/sites-solar`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            if (phase !== undefined) {
                localVarQueryParameter['phase'] = phase;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSolarCurrentStats: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSolarCurrentStats', 'id', id);
            const localVarPath = `/schemas/{id}/solar/stats/current`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {string} [timezone] Users IANA timezone.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSummary: (id, timezone, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSummary', 'id', id);
            const localVarPath = `/schemas/{id}/summary`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            // authentication ApiSoftAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (timezone !== undefined) {
                localVarQueryParameter['timezone'] = timezone;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {string} resourceType Resource type; e.g.: organisations or sites.
         * @param {string} resourceType2 Resource type; e.g.: organisations or sites.
         * @param {string} attributeId ID of the custom attribute.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listResourceTypeCustomAttributeValues: (id, resourceType, resourceType2, attributeId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('listResourceTypeCustomAttributeValues', 'id', id);
            // verify required parameter 'resourceType' is not null or undefined
            assertParamExists('listResourceTypeCustomAttributeValues', 'resourceType', resourceType);
            // verify required parameter 'resourceType2' is not null or undefined
            assertParamExists('listResourceTypeCustomAttributeValues', 'resourceType2', resourceType2);
            // verify required parameter 'attributeId' is not null or undefined
            assertParamExists('listResourceTypeCustomAttributeValues', 'attributeId', attributeId);
            const localVarPath = `/schemas/{id}/attributes/{attributeId}/{resourceType}/values`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"resourceType"}}`, encodeURIComponent(String(resourceType)))
                .replace(`{${"resourceType"}}`, encodeURIComponent(String(resourceType2)))
                .replace(`{${"attributeId"}}`, encodeURIComponent(String(attributeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {string} term The search term.
         * @param {number} [page] Page of results to return.
         * @param {number} [limit] Limit of results to return.
         * @param {string} [timezone] Users IANA timezone.
         * @param {boolean} [extendedDetails] Attach extended details to the sites.
         * @param {boolean} [stats] Attach stats to the sites.
         * @param {boolean} [weather] Attach weather to the sites.
         * @param {string} [resourceMode] Search mode for returning different types of resources; all (all organisations and sites), organisations (single-sibling sites and organisations with 0 or more than 1 site) or sites (sites only).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchResources: (id, term, page, limit, timezone, extendedDetails, stats, weather, resourceMode, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('searchResources', 'id', id);
            // verify required parameter 'term' is not null or undefined
            assertParamExists('searchResources', 'term', term);
            const localVarPath = `/schemas/{id}/resources`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (timezone !== undefined) {
                localVarQueryParameter['timezone'] = timezone;
            }
            if (extendedDetails !== undefined) {
                localVarQueryParameter['extendedDetails'] = extendedDetails;
            }
            if (stats !== undefined) {
                localVarQueryParameter['stats'] = stats;
            }
            if (weather !== undefined) {
                localVarQueryParameter['weather'] = weather;
            }
            if (resourceMode !== undefined) {
                localVarQueryParameter['resourceMode'] = resourceMode;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {string} term The search term.
         * @param {number} [page] Page of results to return.
         * @param {number} [limit] Limit of results to return.
         * @param {string} [timezone] Users IANA timezone.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSites: (id, term, page, limit, timezone, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('searchSites', 'id', id);
            // verify required parameter 'term' is not null or undefined
            assertParamExists('searchSites', 'term', term);
            const localVarPath = `/schemas/{id}/sites/search`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (timezone !== undefined) {
                localVarQueryParameter['timezone'] = timezone;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {string} [limit] Maximum number of sites to return.
         * @param {string} [orderBy] Ordering of the result set.
         * @param {string} [order] Direction of the ordering; defaults to desc.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        siteRankings: (id, limit, orderBy, order, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('siteRankings', 'id', id);
            const localVarPath = `/schemas/{id}/sites/ranking`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {UpdateSchema} [updateSchema] Payload for updating a schema.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: (id, updateSchema, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id);
            const localVarPath = `/schemas/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateSchema, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * SchemasApi - functional programming interface
 * @export
 */
export const SchemasApiFp = function (configuration) {
    const localVarAxiosParamCreator = SchemasApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {CreateSchema} [createSchema] Payload for creating a new schema.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createSchema, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.create(createSchema, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.get(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {number} [page] Page of results to return.
         * @param {number} [limit] Limit of results to return.
         * @param {number} [status] Filter results by status.
         * @param {string} [name] Filter results by name.
         * @param {string} [email] Filter results by email.
         * @param {string} [state] Filter results by state.
         * @param {string} [country] Filter results by country.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContractors(id, page, limit, status, name, email, state, country, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getContractors(id, page, limit, status, name, email, state, country, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnergyBreakdown(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getEnergyBreakdown(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {string} start The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
         * @param {string} [end] The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - format without a timezone.
         * @param {string} [aggregation] Suggested aggregation of the data. Is not guaranteed if date range is too large for the aggregation type.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnergyDataFeed(id, start, end, aggregation, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getEnergyDataFeed(id, start, end, aggregation, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {string} [timezone] Users IANA timezone.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnergyLifetimeSummary(id, timezone, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getEnergyLifetimeSummary(id, timezone, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} [type] Type filter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getList(type, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getList(type, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {string} [filter] Filter for the name of the site.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMapSites(id, filter, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMapSites(id, filter, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {string} slug Slug of the resource.
         * @param {string} [timezone] IANA timezone of the caller to determine the contextual current day. Defaults to Australia/Brisbane; e.g.: Australia/Brisbane
         * @param {boolean} [weather] Attach weather if it is a site resource.
         * @param {boolean} [summary] Attach summary if it is a site resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResourceBySlug(id, slug, timezone, weather, summary, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getResourceBySlug(id, slug, timezone, weather, summary, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} resourceType Resource type; e.g.: organisations or sites.
         * @param {Array<number>} ids List of schema IDs.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResourceTypeCustomAttributes(resourceType, ids, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getResourceTypeCustomAttributes(resourceType, ids, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {string} [timezone] IANA timezone of the caller to determine the contextual current day. Defaults to Australia/Brisbane.
         * @param {number} [phase] Installation phase of the program.
         * @param {number} [days] Number of days to analyse. Defaults to 28.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSavingsGuaranteeFeed(id, timezone, phase, days, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSavingsGuaranteeFeed(id, timezone, phase, days, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {string} [timezone] IANA timezone of the caller to determine the contextual current day. Defaults to Australia/Brisbane.
         * @param {number} [phase] Installation phase of the program.
         * @param {number} [days] Number of days to analyse. Defaults to 28.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSavingsGuaranteeSummary(id, timezone, phase, days, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSavingsGuaranteeSummary(id, timezone, phase, days, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {number} [page] Page of results to return.
         * @param {number} [limit] Limit of results to return.
         * @param {string} [filter] Filter for the organisation name of the site.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSites(id, page, limit, filter, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSites(id, page, limit, filter, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {number} [phase] Installation phase to filter by.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSitesSolarReport(id, phase, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSitesSolarReport(id, phase, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSolarCurrentStats(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSolarCurrentStats(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {string} [timezone] Users IANA timezone.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSummary(id, timezone, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSummary(id, timezone, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {string} resourceType Resource type; e.g.: organisations or sites.
         * @param {string} resourceType2 Resource type; e.g.: organisations or sites.
         * @param {string} attributeId ID of the custom attribute.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listResourceTypeCustomAttributeValues(id, resourceType, resourceType2, attributeId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listResourceTypeCustomAttributeValues(id, resourceType, resourceType2, attributeId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {string} term The search term.
         * @param {number} [page] Page of results to return.
         * @param {number} [limit] Limit of results to return.
         * @param {string} [timezone] Users IANA timezone.
         * @param {boolean} [extendedDetails] Attach extended details to the sites.
         * @param {boolean} [stats] Attach stats to the sites.
         * @param {boolean} [weather] Attach weather to the sites.
         * @param {string} [resourceMode] Search mode for returning different types of resources; all (all organisations and sites), organisations (single-sibling sites and organisations with 0 or more than 1 site) or sites (sites only).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchResources(id, term, page, limit, timezone, extendedDetails, stats, weather, resourceMode, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchResources(id, term, page, limit, timezone, extendedDetails, stats, weather, resourceMode, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {string} term The search term.
         * @param {number} [page] Page of results to return.
         * @param {number} [limit] Limit of results to return.
         * @param {string} [timezone] Users IANA timezone.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSites(id, term, page, limit, timezone, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchSites(id, term, page, limit, timezone, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {string} [limit] Maximum number of sites to return.
         * @param {string} [orderBy] Ordering of the result set.
         * @param {string} [order] Direction of the ordering; defaults to desc.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        siteRankings(id, limit, orderBy, order, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.siteRankings(id, limit, orderBy, order, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {UpdateSchema} [updateSchema] Payload for updating a schema.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id, updateSchema, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.update(id, updateSchema, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * SchemasApi - factory interface
 * @export
 */
export const SchemasApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SchemasApiFp(configuration);
    return {
        /**
         *
         * @param {CreateSchema} [createSchema] Payload for creating a new schema.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createSchema, options) {
            return localVarFp.create(createSchema, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id, options) {
            return localVarFp.get(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {number} [page] Page of results to return.
         * @param {number} [limit] Limit of results to return.
         * @param {number} [status] Filter results by status.
         * @param {string} [name] Filter results by name.
         * @param {string} [email] Filter results by email.
         * @param {string} [state] Filter results by state.
         * @param {string} [country] Filter results by country.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContractors(id, page, limit, status, name, email, state, country, options) {
            return localVarFp.getContractors(id, page, limit, status, name, email, state, country, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnergyBreakdown(id, options) {
            return localVarFp.getEnergyBreakdown(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {string} start The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
         * @param {string} [end] The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - format without a timezone.
         * @param {string} [aggregation] Suggested aggregation of the data. Is not guaranteed if date range is too large for the aggregation type.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnergyDataFeed(id, start, end, aggregation, options) {
            return localVarFp.getEnergyDataFeed(id, start, end, aggregation, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {string} [timezone] Users IANA timezone.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnergyLifetimeSummary(id, timezone, options) {
            return localVarFp.getEnergyLifetimeSummary(id, timezone, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [type] Type filter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getList(type, options) {
            return localVarFp.getList(type, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {string} [filter] Filter for the name of the site.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMapSites(id, filter, options) {
            return localVarFp.getMapSites(id, filter, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {string} slug Slug of the resource.
         * @param {string} [timezone] IANA timezone of the caller to determine the contextual current day. Defaults to Australia/Brisbane; e.g.: Australia/Brisbane
         * @param {boolean} [weather] Attach weather if it is a site resource.
         * @param {boolean} [summary] Attach summary if it is a site resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResourceBySlug(id, slug, timezone, weather, summary, options) {
            return localVarFp.getResourceBySlug(id, slug, timezone, weather, summary, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} resourceType Resource type; e.g.: organisations or sites.
         * @param {Array<number>} ids List of schema IDs.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResourceTypeCustomAttributes(resourceType, ids, options) {
            return localVarFp.getResourceTypeCustomAttributes(resourceType, ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {string} [timezone] IANA timezone of the caller to determine the contextual current day. Defaults to Australia/Brisbane.
         * @param {number} [phase] Installation phase of the program.
         * @param {number} [days] Number of days to analyse. Defaults to 28.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSavingsGuaranteeFeed(id, timezone, phase, days, options) {
            return localVarFp.getSavingsGuaranteeFeed(id, timezone, phase, days, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {string} [timezone] IANA timezone of the caller to determine the contextual current day. Defaults to Australia/Brisbane.
         * @param {number} [phase] Installation phase of the program.
         * @param {number} [days] Number of days to analyse. Defaults to 28.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSavingsGuaranteeSummary(id, timezone, phase, days, options) {
            return localVarFp.getSavingsGuaranteeSummary(id, timezone, phase, days, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {number} [page] Page of results to return.
         * @param {number} [limit] Limit of results to return.
         * @param {string} [filter] Filter for the organisation name of the site.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSites(id, page, limit, filter, options) {
            return localVarFp.getSites(id, page, limit, filter, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {number} [phase] Installation phase to filter by.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSitesSolarReport(id, phase, options) {
            return localVarFp.getSitesSolarReport(id, phase, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSolarCurrentStats(id, options) {
            return localVarFp.getSolarCurrentStats(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {string} [timezone] Users IANA timezone.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSummary(id, timezone, options) {
            return localVarFp.getSummary(id, timezone, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {string} resourceType Resource type; e.g.: organisations or sites.
         * @param {string} resourceType2 Resource type; e.g.: organisations or sites.
         * @param {string} attributeId ID of the custom attribute.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listResourceTypeCustomAttributeValues(id, resourceType, resourceType2, attributeId, options) {
            return localVarFp.listResourceTypeCustomAttributeValues(id, resourceType, resourceType2, attributeId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {string} term The search term.
         * @param {number} [page] Page of results to return.
         * @param {number} [limit] Limit of results to return.
         * @param {string} [timezone] Users IANA timezone.
         * @param {boolean} [extendedDetails] Attach extended details to the sites.
         * @param {boolean} [stats] Attach stats to the sites.
         * @param {boolean} [weather] Attach weather to the sites.
         * @param {string} [resourceMode] Search mode for returning different types of resources; all (all organisations and sites), organisations (single-sibling sites and organisations with 0 or more than 1 site) or sites (sites only).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchResources(id, term, page, limit, timezone, extendedDetails, stats, weather, resourceMode, options) {
            return localVarFp.searchResources(id, term, page, limit, timezone, extendedDetails, stats, weather, resourceMode, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {string} term The search term.
         * @param {number} [page] Page of results to return.
         * @param {number} [limit] Limit of results to return.
         * @param {string} [timezone] Users IANA timezone.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSites(id, term, page, limit, timezone, options) {
            return localVarFp.searchSites(id, term, page, limit, timezone, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {string} [limit] Maximum number of sites to return.
         * @param {string} [orderBy] Ordering of the result set.
         * @param {string} [order] Direction of the ordering; defaults to desc.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        siteRankings(id, limit, orderBy, order, options) {
            return localVarFp.siteRankings(id, limit, orderBy, order, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {UpdateSchema} [updateSchema] Payload for updating a schema.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id, updateSchema, options) {
            return localVarFp.update(id, updateSchema, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SchemasApi - object-oriented interface
 * @export
 * @class SchemasApi
 * @extends {BaseAPI}
 */
export class SchemasApi extends BaseAPI {
    /**
     *
     * @param {CreateSchema} [createSchema] Payload for creating a new schema.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchemasApi
     */
    create(createSchema, options) {
        return SchemasApiFp(this.configuration).create(createSchema, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchemasApi
     */
    get(id, options) {
        return SchemasApiFp(this.configuration).get(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {number} [page] Page of results to return.
     * @param {number} [limit] Limit of results to return.
     * @param {number} [status] Filter results by status.
     * @param {string} [name] Filter results by name.
     * @param {string} [email] Filter results by email.
     * @param {string} [state] Filter results by state.
     * @param {string} [country] Filter results by country.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchemasApi
     */
    getContractors(id, page, limit, status, name, email, state, country, options) {
        return SchemasApiFp(this.configuration).getContractors(id, page, limit, status, name, email, state, country, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchemasApi
     */
    getEnergyBreakdown(id, options) {
        return SchemasApiFp(this.configuration).getEnergyBreakdown(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {string} start The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
     * @param {string} [end] The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - format without a timezone.
     * @param {string} [aggregation] Suggested aggregation of the data. Is not guaranteed if date range is too large for the aggregation type.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchemasApi
     */
    getEnergyDataFeed(id, start, end, aggregation, options) {
        return SchemasApiFp(this.configuration).getEnergyDataFeed(id, start, end, aggregation, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {string} [timezone] Users IANA timezone.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchemasApi
     */
    getEnergyLifetimeSummary(id, timezone, options) {
        return SchemasApiFp(this.configuration).getEnergyLifetimeSummary(id, timezone, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [type] Type filter.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchemasApi
     */
    getList(type, options) {
        return SchemasApiFp(this.configuration).getList(type, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {string} [filter] Filter for the name of the site.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchemasApi
     */
    getMapSites(id, filter, options) {
        return SchemasApiFp(this.configuration).getMapSites(id, filter, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {string} slug Slug of the resource.
     * @param {string} [timezone] IANA timezone of the caller to determine the contextual current day. Defaults to Australia/Brisbane; e.g.: Australia/Brisbane
     * @param {boolean} [weather] Attach weather if it is a site resource.
     * @param {boolean} [summary] Attach summary if it is a site resource.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchemasApi
     */
    getResourceBySlug(id, slug, timezone, weather, summary, options) {
        return SchemasApiFp(this.configuration).getResourceBySlug(id, slug, timezone, weather, summary, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} resourceType Resource type; e.g.: organisations or sites.
     * @param {Array<number>} ids List of schema IDs.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchemasApi
     */
    getResourceTypeCustomAttributes(resourceType, ids, options) {
        return SchemasApiFp(this.configuration).getResourceTypeCustomAttributes(resourceType, ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {string} [timezone] IANA timezone of the caller to determine the contextual current day. Defaults to Australia/Brisbane.
     * @param {number} [phase] Installation phase of the program.
     * @param {number} [days] Number of days to analyse. Defaults to 28.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchemasApi
     */
    getSavingsGuaranteeFeed(id, timezone, phase, days, options) {
        return SchemasApiFp(this.configuration).getSavingsGuaranteeFeed(id, timezone, phase, days, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {string} [timezone] IANA timezone of the caller to determine the contextual current day. Defaults to Australia/Brisbane.
     * @param {number} [phase] Installation phase of the program.
     * @param {number} [days] Number of days to analyse. Defaults to 28.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchemasApi
     */
    getSavingsGuaranteeSummary(id, timezone, phase, days, options) {
        return SchemasApiFp(this.configuration).getSavingsGuaranteeSummary(id, timezone, phase, days, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {number} [page] Page of results to return.
     * @param {number} [limit] Limit of results to return.
     * @param {string} [filter] Filter for the organisation name of the site.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchemasApi
     */
    getSites(id, page, limit, filter, options) {
        return SchemasApiFp(this.configuration).getSites(id, page, limit, filter, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {number} [phase] Installation phase to filter by.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchemasApi
     */
    getSitesSolarReport(id, phase, options) {
        return SchemasApiFp(this.configuration).getSitesSolarReport(id, phase, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchemasApi
     */
    getSolarCurrentStats(id, options) {
        return SchemasApiFp(this.configuration).getSolarCurrentStats(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {string} [timezone] Users IANA timezone.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchemasApi
     */
    getSummary(id, timezone, options) {
        return SchemasApiFp(this.configuration).getSummary(id, timezone, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {string} resourceType Resource type; e.g.: organisations or sites.
     * @param {string} resourceType2 Resource type; e.g.: organisations or sites.
     * @param {string} attributeId ID of the custom attribute.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchemasApi
     */
    listResourceTypeCustomAttributeValues(id, resourceType, resourceType2, attributeId, options) {
        return SchemasApiFp(this.configuration).listResourceTypeCustomAttributeValues(id, resourceType, resourceType2, attributeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {string} term The search term.
     * @param {number} [page] Page of results to return.
     * @param {number} [limit] Limit of results to return.
     * @param {string} [timezone] Users IANA timezone.
     * @param {boolean} [extendedDetails] Attach extended details to the sites.
     * @param {boolean} [stats] Attach stats to the sites.
     * @param {boolean} [weather] Attach weather to the sites.
     * @param {string} [resourceMode] Search mode for returning different types of resources; all (all organisations and sites), organisations (single-sibling sites and organisations with 0 or more than 1 site) or sites (sites only).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchemasApi
     */
    searchResources(id, term, page, limit, timezone, extendedDetails, stats, weather, resourceMode, options) {
        return SchemasApiFp(this.configuration).searchResources(id, term, page, limit, timezone, extendedDetails, stats, weather, resourceMode, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {string} term The search term.
     * @param {number} [page] Page of results to return.
     * @param {number} [limit] Limit of results to return.
     * @param {string} [timezone] Users IANA timezone.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchemasApi
     */
    searchSites(id, term, page, limit, timezone, options) {
        return SchemasApiFp(this.configuration).searchSites(id, term, page, limit, timezone, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {string} [limit] Maximum number of sites to return.
     * @param {string} [orderBy] Ordering of the result set.
     * @param {string} [order] Direction of the ordering; defaults to desc.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchemasApi
     */
    siteRankings(id, limit, orderBy, order, options) {
        return SchemasApiFp(this.configuration).siteRankings(id, limit, orderBy, order, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {UpdateSchema} [updateSchema] Payload for updating a schema.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchemasApi
     */
    update(id, updateSchema, options) {
        return SchemasApiFp(this.configuration).update(id, updateSchema, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * SitesApi - axios parameter creator
 * @export
 */
export const SitesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('_delete', 'id', id);
            const localVarPath = `/sites/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CreateSite} [createSite] Payload for creating a new site.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: (createSite, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/sites/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createSite, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {CreatePopulation} [createPopulation] Payload for creating a new population for a site.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPopulation: (id, createPopulation, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createPopulation', 'id', id);
            const localVarPath = `/sites/{id}/population`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createPopulation, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {CreateSavingsGuarantee} [createSavingsGuarantee] Payload for creating a new savings guarantee for a site.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSavingsGuarantee: (id, createSavingsGuarantee, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createSavingsGuarantee', 'id', id);
            const localVarPath = `/sites/{id}/savings-guarantee`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createSavingsGuarantee, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id ID of the site.
         * @param {string} startDate Start date of the population in yyyy-mm-dd format.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePopulation: (id, startDate, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deletePopulation', 'id', id);
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('deletePopulation', 'startDate', startDate);
            const localVarPath = `/sites/{id}/population/{startDate}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"startDate"}}`, encodeURIComponent(String(startDate)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {string} [timezone] IANA timezone of the caller to determine the contextual current day. Defaults to Australia/Brisbane
         * @param {string} [customAttributes] IANA timezone of the caller to determine the contextual current day. Defaults to Australia/Brisbane
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: (id, timezone, customAttributes, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('get', 'id', id);
            const localVarPath = `/sites/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (timezone !== undefined) {
                localVarQueryParameter['timezone'] = timezone;
            }
            if (customAttributes !== undefined) {
                localVarQueryParameter['customAttributes'] = customAttributes;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {string} start The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
         * @param {string} [end] The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
         * @param {string} [aggregation] Suggested aggregation of the data. Is not guaranteed if date range is too large for the aggregation type.
         * @param {string} [grouping] Grouping of the submeters breakdown; type, group or none; default: none.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnergyBreakdown: (id, start, end, aggregation, grouping, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getEnergyBreakdown', 'id', id);
            // verify required parameter 'start' is not null or undefined
            assertParamExists('getEnergyBreakdown', 'start', start);
            const localVarPath = `/sites/{id}/energy/breakdown`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (start !== undefined) {
                localVarQueryParameter['start'] = start;
            }
            if (end !== undefined) {
                localVarQueryParameter['end'] = end;
            }
            if (aggregation !== undefined) {
                localVarQueryParameter['aggregation'] = aggregation;
            }
            if (grouping !== undefined) {
                localVarQueryParameter['grouping'] = grouping;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {string} start The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
         * @param {string} [end] The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
         * @param {string} [aggregation] Suggested aggregation of the data. Is not guaranteed if date range is too large for the aggregation type.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnergyDataFeed: (id, start, end, aggregation, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getEnergyDataFeed', 'id', id);
            // verify required parameter 'start' is not null or undefined
            assertParamExists('getEnergyDataFeed', 'start', start);
            const localVarPath = `/sites/{id}/energy/data-feed`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (start !== undefined) {
                localVarQueryParameter['start'] = start;
            }
            if (end !== undefined) {
                localVarQueryParameter['end'] = end;
            }
            if (aggregation !== undefined) {
                localVarQueryParameter['aggregation'] = aggregation;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnergyLifetimeData: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getEnergyLifetimeData', 'id', id);
            const localVarPath = `/sites/{id}/energy/lifetime-data`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeters: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getMeters', 'id', id);
            const localVarPath = `/sites/{id}/meters`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {number} [utility] Utility type of the meter.
         * @param {Array<number>} [types] Filter of the type of the physical meter.
         * @param {Array<number>} [excludeTypes] Filter of the types of the physical meter to exclude.
         * @param {number} [status] Filter of the status of the physical meter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPhysicalMeters: (id, utility, types, excludeTypes, status, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPhysicalMeters', 'id', id);
            const localVarPath = `/sites/{id}/meters/physical`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            if (utility !== undefined) {
                localVarQueryParameter['utility'] = utility;
            }
            if (types) {
                localVarQueryParameter['types'] = types;
            }
            if (excludeTypes) {
                localVarQueryParameter['excludeTypes'] = excludeTypes;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {string} [date] Date in the site\&#39;s timezone.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPopulation: (id, date, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPopulation', 'id', id);
            const localVarPath = `/sites/{id}/population`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {string} [date] Date in the site\&#39;s timezone.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSavingsGuarantee: (id, date, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSavingsGuarantee', 'id', id);
            const localVarPath = `/sites/{id}/savings-guarantee`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {string} [date] Date in the site\&#39;s timezone.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSavingsGuaranteeDailyFeed: (id, date, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSavingsGuaranteeDailyFeed', 'id', id);
            const localVarPath = `/sites/{id}/savings-guarantee/feed/daily`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {string} [date] Date in the site\&#39;s timezone.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSavingsGuaranteeFeed: (id, date, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSavingsGuaranteeFeed', 'id', id);
            const localVarPath = `/sites/{id}/savings-guarantee/feed`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {string} [timezone] The end-users IANA timezone.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSummary: (id, timezone, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSummary', 'id', id);
            const localVarPath = `/sites/{id}/summary`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            // authentication ApiSoftAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (timezone !== undefined) {
                localVarQueryParameter['timezone'] = timezone;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {Array<number>} [type] List of note types to filter by.
         * @param {number} [page] Page of results to return.
         * @param {number} [limit] Limit of results to return.
         * @param {string} [order] Ordering fo the results; asc or desc.
         * @param {string} [orderBy] Column to order the results by; eventDate, id, resourceType, or created.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportNotes: (id, type, page, limit, order, orderBy, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSupportNotes', 'id', id);
            const localVarPath = `/sites/{id}/support-notes`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            if (type) {
                localVarQueryParameter['type'] = type;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSystems: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSystems', 'id', id);
            const localVarPath = `/sites/{id}/systems`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {string} start The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
         * @param {string} [end] The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
         * @param {boolean} [includeDisabled] Include disabled virtual meter data sources.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSystemsDataFeed: (id, start, end, includeDisabled, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSystemsDataFeed', 'id', id);
            // verify required parameter 'start' is not null or undefined
            assertParamExists('getSystemsDataFeed', 'start', start);
            const localVarPath = `/sites/{id}/systems/data-feed`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (start !== undefined) {
                localVarQueryParameter['start'] = start;
            }
            if (end !== undefined) {
                localVarQueryParameter['end'] = end;
            }
            if (includeDisabled !== undefined) {
                localVarQueryParameter['includeDisabled'] = includeDisabled;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {number} [parentId] ID of the parent.
         * @param {Array<number>} [types] Filter of the type of the virtual meter.
         * @param {Array<number>} [excludeTypes] Filter of the types of the virtual meter to exclude.
         * @param {Array<string>} [nodeTypes] Type of nodes to match: grid, generator or battery.
         * @param {Array<string>} [excludeNodeTypes] Type of nodes to not match: grid, generator or battery.
         * @param {number} [status] Filter of the status of the virtual meter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVirtualMeters: (id, parentId, types, excludeTypes, nodeTypes, excludeNodeTypes, status, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getVirtualMeters', 'id', id);
            const localVarPath = `/sites/{id}/meters/virtual`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (parentId !== undefined) {
                localVarQueryParameter['parentId'] = parentId;
            }
            if (types) {
                localVarQueryParameter['types'] = types;
            }
            if (excludeTypes) {
                localVarQueryParameter['excludeTypes'] = excludeTypes;
            }
            if (nodeTypes) {
                localVarQueryParameter['nodeTypes'] = nodeTypes;
            }
            if (excludeNodeTypes) {
                localVarQueryParameter['excludeNodeTypes'] = excludeNodeTypes;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {string} [date] The requested date for the weather.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWeather: (id, date, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getWeather', 'id', id);
            const localVarPath = `/sites/{id}/weather`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {string} [range] Range of records to select; future, past or all.
         * @param {string} [order] Direction of the ordering; asc or desc - defaults to asc.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPopulation: (id, range, order, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('listPopulation', 'id', id);
            const localVarPath = `/sites/{id}/population/list`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            if (range !== undefined) {
                localVarQueryParameter['range'] = range;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {UpdateSite} [updateSite] Payload for updating an existing site.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: (id, updateSite, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id);
            const localVarPath = `/sites/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateSite, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id ID of the site.
         * @param {string} startDate Start date of the population in yyyy-mm-dd format.
         * @param {UpdatePopulation} [updatePopulation] Payload for updating a new population for a site.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePopulation: (id, startDate, updatePopulation, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updatePopulation', 'id', id);
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('updatePopulation', 'startDate', startDate);
            const localVarPath = `/sites/{id}/population/{startDate}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"startDate"}}`, encodeURIComponent(String(startDate)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updatePopulation, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id ID of the site.
         * @param {string} startDate Start date of the savings guarantee in yyyy-mm-dd format.
         * @param {UpdateSavingsGuarantee} [updateSavingsGuarantee] Payload for creating a new savings guarantee for a site.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSavingsGuarantee: (id, startDate, updateSavingsGuarantee, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateSavingsGuarantee', 'id', id);
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('updateSavingsGuarantee', 'startDate', startDate);
            const localVarPath = `/sites/{id}/savings-guarantee/{startDate}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"startDate"}}`, encodeURIComponent(String(startDate)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateSavingsGuarantee, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * SitesApi - functional programming interface
 * @export
 */
export const SitesApiFp = function (configuration) {
    const localVarAxiosParamCreator = SitesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator._delete(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {CreateSite} [createSite] Payload for creating a new site.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createSite, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.create(createSite, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {CreatePopulation} [createPopulation] Payload for creating a new population for a site.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPopulation(id, createPopulation, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createPopulation(id, createPopulation, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {CreateSavingsGuarantee} [createSavingsGuarantee] Payload for creating a new savings guarantee for a site.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSavingsGuarantee(id, createSavingsGuarantee, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createSavingsGuarantee(id, createSavingsGuarantee, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id ID of the site.
         * @param {string} startDate Start date of the population in yyyy-mm-dd format.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePopulation(id, startDate, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deletePopulation(id, startDate, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {string} [timezone] IANA timezone of the caller to determine the contextual current day. Defaults to Australia/Brisbane
         * @param {string} [customAttributes] IANA timezone of the caller to determine the contextual current day. Defaults to Australia/Brisbane
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id, timezone, customAttributes, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.get(id, timezone, customAttributes, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {string} start The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
         * @param {string} [end] The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
         * @param {string} [aggregation] Suggested aggregation of the data. Is not guaranteed if date range is too large for the aggregation type.
         * @param {string} [grouping] Grouping of the submeters breakdown; type, group or none; default: none.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnergyBreakdown(id, start, end, aggregation, grouping, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getEnergyBreakdown(id, start, end, aggregation, grouping, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {string} start The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
         * @param {string} [end] The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
         * @param {string} [aggregation] Suggested aggregation of the data. Is not guaranteed if date range is too large for the aggregation type.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnergyDataFeed(id, start, end, aggregation, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getEnergyDataFeed(id, start, end, aggregation, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnergyLifetimeData(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getEnergyLifetimeData(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeters(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMeters(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {number} [utility] Utility type of the meter.
         * @param {Array<number>} [types] Filter of the type of the physical meter.
         * @param {Array<number>} [excludeTypes] Filter of the types of the physical meter to exclude.
         * @param {number} [status] Filter of the status of the physical meter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPhysicalMeters(id, utility, types, excludeTypes, status, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPhysicalMeters(id, utility, types, excludeTypes, status, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {string} [date] Date in the site\&#39;s timezone.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPopulation(id, date, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPopulation(id, date, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {string} [date] Date in the site\&#39;s timezone.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSavingsGuarantee(id, date, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSavingsGuarantee(id, date, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {string} [date] Date in the site\&#39;s timezone.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSavingsGuaranteeDailyFeed(id, date, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSavingsGuaranteeDailyFeed(id, date, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {string} [date] Date in the site\&#39;s timezone.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSavingsGuaranteeFeed(id, date, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSavingsGuaranteeFeed(id, date, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {string} [timezone] The end-users IANA timezone.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSummary(id, timezone, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSummary(id, timezone, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {Array<number>} [type] List of note types to filter by.
         * @param {number} [page] Page of results to return.
         * @param {number} [limit] Limit of results to return.
         * @param {string} [order] Ordering fo the results; asc or desc.
         * @param {string} [orderBy] Column to order the results by; eventDate, id, resourceType, or created.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportNotes(id, type, page, limit, order, orderBy, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSupportNotes(id, type, page, limit, order, orderBy, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSystems(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSystems(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {string} start The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
         * @param {string} [end] The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
         * @param {boolean} [includeDisabled] Include disabled virtual meter data sources.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSystemsDataFeed(id, start, end, includeDisabled, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSystemsDataFeed(id, start, end, includeDisabled, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {number} [parentId] ID of the parent.
         * @param {Array<number>} [types] Filter of the type of the virtual meter.
         * @param {Array<number>} [excludeTypes] Filter of the types of the virtual meter to exclude.
         * @param {Array<string>} [nodeTypes] Type of nodes to match: grid, generator or battery.
         * @param {Array<string>} [excludeNodeTypes] Type of nodes to not match: grid, generator or battery.
         * @param {number} [status] Filter of the status of the virtual meter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVirtualMeters(id, parentId, types, excludeTypes, nodeTypes, excludeNodeTypes, status, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getVirtualMeters(id, parentId, types, excludeTypes, nodeTypes, excludeNodeTypes, status, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {string} [date] The requested date for the weather.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWeather(id, date, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getWeather(id, date, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {string} [range] Range of records to select; future, past or all.
         * @param {string} [order] Direction of the ordering; asc or desc - defaults to asc.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPopulation(id, range, order, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listPopulation(id, range, order, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {UpdateSite} [updateSite] Payload for updating an existing site.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id, updateSite, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.update(id, updateSite, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id ID of the site.
         * @param {string} startDate Start date of the population in yyyy-mm-dd format.
         * @param {UpdatePopulation} [updatePopulation] Payload for updating a new population for a site.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePopulation(id, startDate, updatePopulation, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updatePopulation(id, startDate, updatePopulation, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id ID of the site.
         * @param {string} startDate Start date of the savings guarantee in yyyy-mm-dd format.
         * @param {UpdateSavingsGuarantee} [updateSavingsGuarantee] Payload for creating a new savings guarantee for a site.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSavingsGuarantee(id, startDate, updateSavingsGuarantee, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateSavingsGuarantee(id, startDate, updateSavingsGuarantee, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * SitesApi - factory interface
 * @export
 */
export const SitesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SitesApiFp(configuration);
    return {
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(id, options) {
            return localVarFp._delete(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateSite} [createSite] Payload for creating a new site.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createSite, options) {
            return localVarFp.create(createSite, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {CreatePopulation} [createPopulation] Payload for creating a new population for a site.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPopulation(id, createPopulation, options) {
            return localVarFp.createPopulation(id, createPopulation, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {CreateSavingsGuarantee} [createSavingsGuarantee] Payload for creating a new savings guarantee for a site.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSavingsGuarantee(id, createSavingsGuarantee, options) {
            return localVarFp.createSavingsGuarantee(id, createSavingsGuarantee, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id ID of the site.
         * @param {string} startDate Start date of the population in yyyy-mm-dd format.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePopulation(id, startDate, options) {
            return localVarFp.deletePopulation(id, startDate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {string} [timezone] IANA timezone of the caller to determine the contextual current day. Defaults to Australia/Brisbane
         * @param {string} [customAttributes] IANA timezone of the caller to determine the contextual current day. Defaults to Australia/Brisbane
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id, timezone, customAttributes, options) {
            return localVarFp.get(id, timezone, customAttributes, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {string} start The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
         * @param {string} [end] The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
         * @param {string} [aggregation] Suggested aggregation of the data. Is not guaranteed if date range is too large for the aggregation type.
         * @param {string} [grouping] Grouping of the submeters breakdown; type, group or none; default: none.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnergyBreakdown(id, start, end, aggregation, grouping, options) {
            return localVarFp.getEnergyBreakdown(id, start, end, aggregation, grouping, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {string} start The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
         * @param {string} [end] The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
         * @param {string} [aggregation] Suggested aggregation of the data. Is not guaranteed if date range is too large for the aggregation type.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnergyDataFeed(id, start, end, aggregation, options) {
            return localVarFp.getEnergyDataFeed(id, start, end, aggregation, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnergyLifetimeData(id, options) {
            return localVarFp.getEnergyLifetimeData(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeters(id, options) {
            return localVarFp.getMeters(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {number} [utility] Utility type of the meter.
         * @param {Array<number>} [types] Filter of the type of the physical meter.
         * @param {Array<number>} [excludeTypes] Filter of the types of the physical meter to exclude.
         * @param {number} [status] Filter of the status of the physical meter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPhysicalMeters(id, utility, types, excludeTypes, status, options) {
            return localVarFp.getPhysicalMeters(id, utility, types, excludeTypes, status, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {string} [date] Date in the site\&#39;s timezone.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPopulation(id, date, options) {
            return localVarFp.getPopulation(id, date, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {string} [date] Date in the site\&#39;s timezone.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSavingsGuarantee(id, date, options) {
            return localVarFp.getSavingsGuarantee(id, date, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {string} [date] Date in the site\&#39;s timezone.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSavingsGuaranteeDailyFeed(id, date, options) {
            return localVarFp.getSavingsGuaranteeDailyFeed(id, date, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {string} [date] Date in the site\&#39;s timezone.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSavingsGuaranteeFeed(id, date, options) {
            return localVarFp.getSavingsGuaranteeFeed(id, date, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {string} [timezone] The end-users IANA timezone.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSummary(id, timezone, options) {
            return localVarFp.getSummary(id, timezone, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {Array<number>} [type] List of note types to filter by.
         * @param {number} [page] Page of results to return.
         * @param {number} [limit] Limit of results to return.
         * @param {string} [order] Ordering fo the results; asc or desc.
         * @param {string} [orderBy] Column to order the results by; eventDate, id, resourceType, or created.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportNotes(id, type, page, limit, order, orderBy, options) {
            return localVarFp.getSupportNotes(id, type, page, limit, order, orderBy, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSystems(id, options) {
            return localVarFp.getSystems(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {string} start The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
         * @param {string} [end] The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
         * @param {boolean} [includeDisabled] Include disabled virtual meter data sources.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSystemsDataFeed(id, start, end, includeDisabled, options) {
            return localVarFp.getSystemsDataFeed(id, start, end, includeDisabled, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {number} [parentId] ID of the parent.
         * @param {Array<number>} [types] Filter of the type of the virtual meter.
         * @param {Array<number>} [excludeTypes] Filter of the types of the virtual meter to exclude.
         * @param {Array<string>} [nodeTypes] Type of nodes to match: grid, generator or battery.
         * @param {Array<string>} [excludeNodeTypes] Type of nodes to not match: grid, generator or battery.
         * @param {number} [status] Filter of the status of the virtual meter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVirtualMeters(id, parentId, types, excludeTypes, nodeTypes, excludeNodeTypes, status, options) {
            return localVarFp.getVirtualMeters(id, parentId, types, excludeTypes, nodeTypes, excludeNodeTypes, status, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {string} [date] The requested date for the weather.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWeather(id, date, options) {
            return localVarFp.getWeather(id, date, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {string} [range] Range of records to select; future, past or all.
         * @param {string} [order] Direction of the ordering; asc or desc - defaults to asc.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPopulation(id, range, order, options) {
            return localVarFp.listPopulation(id, range, order, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {UpdateSite} [updateSite] Payload for updating an existing site.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id, updateSite, options) {
            return localVarFp.update(id, updateSite, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id ID of the site.
         * @param {string} startDate Start date of the population in yyyy-mm-dd format.
         * @param {UpdatePopulation} [updatePopulation] Payload for updating a new population for a site.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePopulation(id, startDate, updatePopulation, options) {
            return localVarFp.updatePopulation(id, startDate, updatePopulation, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id ID of the site.
         * @param {string} startDate Start date of the savings guarantee in yyyy-mm-dd format.
         * @param {UpdateSavingsGuarantee} [updateSavingsGuarantee] Payload for creating a new savings guarantee for a site.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSavingsGuarantee(id, startDate, updateSavingsGuarantee, options) {
            return localVarFp.updateSavingsGuarantee(id, startDate, updateSavingsGuarantee, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SitesApi - object-oriented interface
 * @export
 * @class SitesApi
 * @extends {BaseAPI}
 */
export class SitesApi extends BaseAPI {
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SitesApi
     */
    _delete(id, options) {
        return SitesApiFp(this.configuration)._delete(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CreateSite} [createSite] Payload for creating a new site.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SitesApi
     */
    create(createSite, options) {
        return SitesApiFp(this.configuration).create(createSite, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {CreatePopulation} [createPopulation] Payload for creating a new population for a site.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SitesApi
     */
    createPopulation(id, createPopulation, options) {
        return SitesApiFp(this.configuration).createPopulation(id, createPopulation, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {CreateSavingsGuarantee} [createSavingsGuarantee] Payload for creating a new savings guarantee for a site.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SitesApi
     */
    createSavingsGuarantee(id, createSavingsGuarantee, options) {
        return SitesApiFp(this.configuration).createSavingsGuarantee(id, createSavingsGuarantee, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id ID of the site.
     * @param {string} startDate Start date of the population in yyyy-mm-dd format.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SitesApi
     */
    deletePopulation(id, startDate, options) {
        return SitesApiFp(this.configuration).deletePopulation(id, startDate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {string} [timezone] IANA timezone of the caller to determine the contextual current day. Defaults to Australia/Brisbane
     * @param {string} [customAttributes] IANA timezone of the caller to determine the contextual current day. Defaults to Australia/Brisbane
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SitesApi
     */
    get(id, timezone, customAttributes, options) {
        return SitesApiFp(this.configuration).get(id, timezone, customAttributes, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {string} start The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
     * @param {string} [end] The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
     * @param {string} [aggregation] Suggested aggregation of the data. Is not guaranteed if date range is too large for the aggregation type.
     * @param {string} [grouping] Grouping of the submeters breakdown; type, group or none; default: none.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SitesApi
     */
    getEnergyBreakdown(id, start, end, aggregation, grouping, options) {
        return SitesApiFp(this.configuration).getEnergyBreakdown(id, start, end, aggregation, grouping, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {string} start The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
     * @param {string} [end] The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
     * @param {string} [aggregation] Suggested aggregation of the data. Is not guaranteed if date range is too large for the aggregation type.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SitesApi
     */
    getEnergyDataFeed(id, start, end, aggregation, options) {
        return SitesApiFp(this.configuration).getEnergyDataFeed(id, start, end, aggregation, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SitesApi
     */
    getEnergyLifetimeData(id, options) {
        return SitesApiFp(this.configuration).getEnergyLifetimeData(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SitesApi
     */
    getMeters(id, options) {
        return SitesApiFp(this.configuration).getMeters(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {number} [utility] Utility type of the meter.
     * @param {Array<number>} [types] Filter of the type of the physical meter.
     * @param {Array<number>} [excludeTypes] Filter of the types of the physical meter to exclude.
     * @param {number} [status] Filter of the status of the physical meter.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SitesApi
     */
    getPhysicalMeters(id, utility, types, excludeTypes, status, options) {
        return SitesApiFp(this.configuration).getPhysicalMeters(id, utility, types, excludeTypes, status, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {string} [date] Date in the site\&#39;s timezone.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SitesApi
     */
    getPopulation(id, date, options) {
        return SitesApiFp(this.configuration).getPopulation(id, date, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {string} [date] Date in the site\&#39;s timezone.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SitesApi
     */
    getSavingsGuarantee(id, date, options) {
        return SitesApiFp(this.configuration).getSavingsGuarantee(id, date, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {string} [date] Date in the site\&#39;s timezone.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SitesApi
     */
    getSavingsGuaranteeDailyFeed(id, date, options) {
        return SitesApiFp(this.configuration).getSavingsGuaranteeDailyFeed(id, date, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {string} [date] Date in the site\&#39;s timezone.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SitesApi
     */
    getSavingsGuaranteeFeed(id, date, options) {
        return SitesApiFp(this.configuration).getSavingsGuaranteeFeed(id, date, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {string} [timezone] The end-users IANA timezone.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SitesApi
     */
    getSummary(id, timezone, options) {
        return SitesApiFp(this.configuration).getSummary(id, timezone, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {Array<number>} [type] List of note types to filter by.
     * @param {number} [page] Page of results to return.
     * @param {number} [limit] Limit of results to return.
     * @param {string} [order] Ordering fo the results; asc or desc.
     * @param {string} [orderBy] Column to order the results by; eventDate, id, resourceType, or created.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SitesApi
     */
    getSupportNotes(id, type, page, limit, order, orderBy, options) {
        return SitesApiFp(this.configuration).getSupportNotes(id, type, page, limit, order, orderBy, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SitesApi
     */
    getSystems(id, options) {
        return SitesApiFp(this.configuration).getSystems(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {string} start The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
     * @param {string} [end] The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
     * @param {boolean} [includeDisabled] Include disabled virtual meter data sources.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SitesApi
     */
    getSystemsDataFeed(id, start, end, includeDisabled, options) {
        return SitesApiFp(this.configuration).getSystemsDataFeed(id, start, end, includeDisabled, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {number} [parentId] ID of the parent.
     * @param {Array<number>} [types] Filter of the type of the virtual meter.
     * @param {Array<number>} [excludeTypes] Filter of the types of the virtual meter to exclude.
     * @param {Array<string>} [nodeTypes] Type of nodes to match: grid, generator or battery.
     * @param {Array<string>} [excludeNodeTypes] Type of nodes to not match: grid, generator or battery.
     * @param {number} [status] Filter of the status of the virtual meter.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SitesApi
     */
    getVirtualMeters(id, parentId, types, excludeTypes, nodeTypes, excludeNodeTypes, status, options) {
        return SitesApiFp(this.configuration).getVirtualMeters(id, parentId, types, excludeTypes, nodeTypes, excludeNodeTypes, status, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {string} [date] The requested date for the weather.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SitesApi
     */
    getWeather(id, date, options) {
        return SitesApiFp(this.configuration).getWeather(id, date, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {string} [range] Range of records to select; future, past or all.
     * @param {string} [order] Direction of the ordering; asc or desc - defaults to asc.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SitesApi
     */
    listPopulation(id, range, order, options) {
        return SitesApiFp(this.configuration).listPopulation(id, range, order, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {UpdateSite} [updateSite] Payload for updating an existing site.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SitesApi
     */
    update(id, updateSite, options) {
        return SitesApiFp(this.configuration).update(id, updateSite, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id ID of the site.
     * @param {string} startDate Start date of the population in yyyy-mm-dd format.
     * @param {UpdatePopulation} [updatePopulation] Payload for updating a new population for a site.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SitesApi
     */
    updatePopulation(id, startDate, updatePopulation, options) {
        return SitesApiFp(this.configuration).updatePopulation(id, startDate, updatePopulation, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id ID of the site.
     * @param {string} startDate Start date of the savings guarantee in yyyy-mm-dd format.
     * @param {UpdateSavingsGuarantee} [updateSavingsGuarantee] Payload for creating a new savings guarantee for a site.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SitesApi
     */
    updateSavingsGuarantee(id, startDate, updateSavingsGuarantee, options) {
        return SitesApiFp(this.configuration).updateSavingsGuarantee(id, startDate, updateSavingsGuarantee, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * SupportNotesApi - axios parameter creator
 * @export
 */
export const SupportNotesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CreateSupportNote} [createSupportNote] Payload for creating a new support note.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: (createSupportNote, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/support-notes/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createSupportNote, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('get', 'id', id);
            const localVarPath = `/support-notes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {UpdateSupportNote} [updateSupportNote] Payload for updating an existing support notes.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: (id, updateSupportNote, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id);
            const localVarPath = `/support-notes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateSupportNote, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * SupportNotesApi - functional programming interface
 * @export
 */
export const SupportNotesApiFp = function (configuration) {
    const localVarAxiosParamCreator = SupportNotesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {CreateSupportNote} [createSupportNote] Payload for creating a new support note.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createSupportNote, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.create(createSupportNote, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.get(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {UpdateSupportNote} [updateSupportNote] Payload for updating an existing support notes.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id, updateSupportNote, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.update(id, updateSupportNote, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * SupportNotesApi - factory interface
 * @export
 */
export const SupportNotesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SupportNotesApiFp(configuration);
    return {
        /**
         *
         * @param {CreateSupportNote} [createSupportNote] Payload for creating a new support note.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createSupportNote, options) {
            return localVarFp.create(createSupportNote, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id, options) {
            return localVarFp.get(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {UpdateSupportNote} [updateSupportNote] Payload for updating an existing support notes.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id, updateSupportNote, options) {
            return localVarFp.update(id, updateSupportNote, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SupportNotesApi - object-oriented interface
 * @export
 * @class SupportNotesApi
 * @extends {BaseAPI}
 */
export class SupportNotesApi extends BaseAPI {
    /**
     *
     * @param {CreateSupportNote} [createSupportNote] Payload for creating a new support note.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportNotesApi
     */
    create(createSupportNote, options) {
        return SupportNotesApiFp(this.configuration).create(createSupportNote, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportNotesApi
     */
    get(id, options) {
        return SupportNotesApiFp(this.configuration).get(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {UpdateSupportNote} [updateSupportNote] Payload for updating an existing support notes.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportNotesApi
     */
    update(id, updateSupportNote, options) {
        return SupportNotesApiFp(this.configuration).update(id, updateSupportNote, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * SystemsApi - axios parameter creator
 * @export
 */
export const SystemsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CreateSolarSystem} [createSolarSystem] Payload for creating a new solar system.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: (createSolarSystem, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/systems/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createSolarSystem, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('get', 'id', id);
            const localVarPath = `/systems/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {UpdateSolarSystem} [updateSolarSystem] Payload for updating an existing solar system.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: (id, updateSolarSystem, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id);
            const localVarPath = `/systems/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateSolarSystem, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * SystemsApi - functional programming interface
 * @export
 */
export const SystemsApiFp = function (configuration) {
    const localVarAxiosParamCreator = SystemsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {CreateSolarSystem} [createSolarSystem] Payload for creating a new solar system.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createSolarSystem, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.create(createSolarSystem, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.get(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {UpdateSolarSystem} [updateSolarSystem] Payload for updating an existing solar system.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id, updateSolarSystem, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.update(id, updateSolarSystem, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * SystemsApi - factory interface
 * @export
 */
export const SystemsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SystemsApiFp(configuration);
    return {
        /**
         *
         * @param {CreateSolarSystem} [createSolarSystem] Payload for creating a new solar system.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createSolarSystem, options) {
            return localVarFp.create(createSolarSystem, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id, options) {
            return localVarFp.get(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {UpdateSolarSystem} [updateSolarSystem] Payload for updating an existing solar system.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id, updateSolarSystem, options) {
            return localVarFp.update(id, updateSolarSystem, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SystemsApi - object-oriented interface
 * @export
 * @class SystemsApi
 * @extends {BaseAPI}
 */
export class SystemsApi extends BaseAPI {
    /**
     *
     * @param {CreateSolarSystem} [createSolarSystem] Payload for creating a new solar system.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemsApi
     */
    create(createSolarSystem, options) {
        return SystemsApiFp(this.configuration).create(createSolarSystem, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemsApi
     */
    get(id, options) {
        return SystemsApiFp(this.configuration).get(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {UpdateSolarSystem} [updateSolarSystem] Payload for updating an existing solar system.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemsApi
     */
    update(id, updateSolarSystem, options) {
        return SystemsApiFp(this.configuration).update(id, updateSolarSystem, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * TariffsApi - axios parameter creator
 * @export
 */
export const TariffsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('_delete', 'id', id);
            const localVarPath = `/tariffs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CreateTariff} [createTariff] Payload for creating a new tariff.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: (createTariff, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/tariffs/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createTariff, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {boolean} [attachCharges] Attach charges to the tariff.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: (id, attachCharges, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('get', 'id', id);
            const localVarPath = `/tariffs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            if (attachCharges !== undefined) {
                localVarQueryParameter['attachCharges'] = attachCharges;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} virtualMeterId ID of the virtual meter to view the bill for.
         * @param {string} [date] Date of the bill to view. If empty, today\&#39;s date will be used.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBill: (virtualMeterId, date, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'virtualMeterId' is not null or undefined
            assertParamExists('getBill', 'virtualMeterId', virtualMeterId);
            const localVarPath = `/tariffs/bill/{virtualMeterId}`
                .replace(`{${"virtualMeterId"}}`, encodeURIComponent(String(virtualMeterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} chargeId ID of the charge to view the detail for.
         * @param {string} [date] Date of the bill to view. If empty, today\&#39;s date will be used.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillChargeDetail: (chargeId, date, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'chargeId' is not null or undefined
            assertParamExists('getBillChargeDetail', 'chargeId', chargeId);
            const localVarPath = `/tariffs/bill/charges/{chargeId}`
                .replace(`{${"chargeId"}}`, encodeURIComponent(String(chargeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [siteId] ID if filtering by site. Either siteId or virtualMeterId is required.
         * @param {number} [virtualMeterId] ID if filtering by virtual meter. Either siteId or virtualMeterId is required.
         * @param {boolean} [active] Return only active tariffs for the current date.
         * @param {string} [energyProvider] Filter for the tariff\&#39;s energy provider.
         * @param {string} [dateMin] Minimum date the tariff must be active; in YYYY-MM-DD format.
         * @param {string} [dateMax] Maximum date the tariff can be active; in YYYY-MM-DD format.
         * @param {Array<number>} [statuses] List of statuses to filter by.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list: (siteId, virtualMeterId, active, energyProvider, dateMin, dateMax, statuses, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/tariffs/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            if (siteId !== undefined) {
                localVarQueryParameter['siteId'] = siteId;
            }
            if (virtualMeterId !== undefined) {
                localVarQueryParameter['virtualMeterId'] = virtualMeterId;
            }
            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }
            if (energyProvider !== undefined) {
                localVarQueryParameter['energyProvider'] = energyProvider;
            }
            if (dateMin !== undefined) {
                localVarQueryParameter['dateMin'] = dateMin;
            }
            if (dateMax !== undefined) {
                localVarQueryParameter['dateMax'] = dateMax;
            }
            if (statuses) {
                localVarQueryParameter['statuses'] = statuses;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {UpdateTariff} [updateTariff] Payload for updating an existing tariff.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: (id, updateTariff, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id);
            const localVarPath = `/tariffs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateTariff, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {UpdateTariffCharge} [updateTariffCharge] Payload for updating an existing tariff charge.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCharge: (id, updateTariffCharge, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateCharge', 'id', id);
            const localVarPath = `/tariffs/charges/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateTariffCharge, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * TariffsApi - functional programming interface
 * @export
 */
export const TariffsApiFp = function (configuration) {
    const localVarAxiosParamCreator = TariffsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator._delete(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {CreateTariff} [createTariff] Payload for creating a new tariff.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createTariff, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.create(createTariff, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {boolean} [attachCharges] Attach charges to the tariff.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id, attachCharges, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.get(id, attachCharges, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} virtualMeterId ID of the virtual meter to view the bill for.
         * @param {string} [date] Date of the bill to view. If empty, today\&#39;s date will be used.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBill(virtualMeterId, date, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getBill(virtualMeterId, date, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} chargeId ID of the charge to view the detail for.
         * @param {string} [date] Date of the bill to view. If empty, today\&#39;s date will be used.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillChargeDetail(chargeId, date, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getBillChargeDetail(chargeId, date, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} [siteId] ID if filtering by site. Either siteId or virtualMeterId is required.
         * @param {number} [virtualMeterId] ID if filtering by virtual meter. Either siteId or virtualMeterId is required.
         * @param {boolean} [active] Return only active tariffs for the current date.
         * @param {string} [energyProvider] Filter for the tariff\&#39;s energy provider.
         * @param {string} [dateMin] Minimum date the tariff must be active; in YYYY-MM-DD format.
         * @param {string} [dateMax] Maximum date the tariff can be active; in YYYY-MM-DD format.
         * @param {Array<number>} [statuses] List of statuses to filter by.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(siteId, virtualMeterId, active, energyProvider, dateMin, dateMax, statuses, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.list(siteId, virtualMeterId, active, energyProvider, dateMin, dateMax, statuses, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {UpdateTariff} [updateTariff] Payload for updating an existing tariff.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id, updateTariff, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.update(id, updateTariff, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {UpdateTariffCharge} [updateTariffCharge] Payload for updating an existing tariff charge.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCharge(id, updateTariffCharge, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateCharge(id, updateTariffCharge, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * TariffsApi - factory interface
 * @export
 */
export const TariffsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = TariffsApiFp(configuration);
    return {
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(id, options) {
            return localVarFp._delete(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateTariff} [createTariff] Payload for creating a new tariff.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createTariff, options) {
            return localVarFp.create(createTariff, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {boolean} [attachCharges] Attach charges to the tariff.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id, attachCharges, options) {
            return localVarFp.get(id, attachCharges, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} virtualMeterId ID of the virtual meter to view the bill for.
         * @param {string} [date] Date of the bill to view. If empty, today\&#39;s date will be used.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBill(virtualMeterId, date, options) {
            return localVarFp.getBill(virtualMeterId, date, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} chargeId ID of the charge to view the detail for.
         * @param {string} [date] Date of the bill to view. If empty, today\&#39;s date will be used.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillChargeDetail(chargeId, date, options) {
            return localVarFp.getBillChargeDetail(chargeId, date, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [siteId] ID if filtering by site. Either siteId or virtualMeterId is required.
         * @param {number} [virtualMeterId] ID if filtering by virtual meter. Either siteId or virtualMeterId is required.
         * @param {boolean} [active] Return only active tariffs for the current date.
         * @param {string} [energyProvider] Filter for the tariff\&#39;s energy provider.
         * @param {string} [dateMin] Minimum date the tariff must be active; in YYYY-MM-DD format.
         * @param {string} [dateMax] Maximum date the tariff can be active; in YYYY-MM-DD format.
         * @param {Array<number>} [statuses] List of statuses to filter by.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(siteId, virtualMeterId, active, energyProvider, dateMin, dateMax, statuses, options) {
            return localVarFp.list(siteId, virtualMeterId, active, energyProvider, dateMin, dateMax, statuses, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {UpdateTariff} [updateTariff] Payload for updating an existing tariff.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id, updateTariff, options) {
            return localVarFp.update(id, updateTariff, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {UpdateTariffCharge} [updateTariffCharge] Payload for updating an existing tariff charge.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCharge(id, updateTariffCharge, options) {
            return localVarFp.updateCharge(id, updateTariffCharge, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * TariffsApi - object-oriented interface
 * @export
 * @class TariffsApi
 * @extends {BaseAPI}
 */
export class TariffsApi extends BaseAPI {
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TariffsApi
     */
    _delete(id, options) {
        return TariffsApiFp(this.configuration)._delete(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CreateTariff} [createTariff] Payload for creating a new tariff.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TariffsApi
     */
    create(createTariff, options) {
        return TariffsApiFp(this.configuration).create(createTariff, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {boolean} [attachCharges] Attach charges to the tariff.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TariffsApi
     */
    get(id, attachCharges, options) {
        return TariffsApiFp(this.configuration).get(id, attachCharges, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} virtualMeterId ID of the virtual meter to view the bill for.
     * @param {string} [date] Date of the bill to view. If empty, today\&#39;s date will be used.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TariffsApi
     */
    getBill(virtualMeterId, date, options) {
        return TariffsApiFp(this.configuration).getBill(virtualMeterId, date, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} chargeId ID of the charge to view the detail for.
     * @param {string} [date] Date of the bill to view. If empty, today\&#39;s date will be used.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TariffsApi
     */
    getBillChargeDetail(chargeId, date, options) {
        return TariffsApiFp(this.configuration).getBillChargeDetail(chargeId, date, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [siteId] ID if filtering by site. Either siteId or virtualMeterId is required.
     * @param {number} [virtualMeterId] ID if filtering by virtual meter. Either siteId or virtualMeterId is required.
     * @param {boolean} [active] Return only active tariffs for the current date.
     * @param {string} [energyProvider] Filter for the tariff\&#39;s energy provider.
     * @param {string} [dateMin] Minimum date the tariff must be active; in YYYY-MM-DD format.
     * @param {string} [dateMax] Maximum date the tariff can be active; in YYYY-MM-DD format.
     * @param {Array<number>} [statuses] List of statuses to filter by.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TariffsApi
     */
    list(siteId, virtualMeterId, active, energyProvider, dateMin, dateMax, statuses, options) {
        return TariffsApiFp(this.configuration).list(siteId, virtualMeterId, active, energyProvider, dateMin, dateMax, statuses, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {UpdateTariff} [updateTariff] Payload for updating an existing tariff.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TariffsApi
     */
    update(id, updateTariff, options) {
        return TariffsApiFp(this.configuration).update(id, updateTariff, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {UpdateTariffCharge} [updateTariffCharge] Payload for updating an existing tariff charge.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TariffsApi
     */
    updateCharge(id, updateTariffCharge, options) {
        return TariffsApiFp(this.configuration).updateCharge(id, updateTariffCharge, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * UsersApi - axios parameter creator
 * @export
 */
export const UsersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('_delete', 'id', id);
            const localVarPath = `/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {UserResourceRoles} [userResourceRoles] Payload for adding roles to an existing user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRoles: (id, userResourceRoles, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addRoles', 'id', id);
            const localVarPath = `/users/{id}/roles`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(userResourceRoles, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CreateUser} [createUser] Payload for creating a new user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: (createUser, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/users/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createUser, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<CreateUser>} [createUser] Payload for creating new users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBulk: (createUser, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/users/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createUser, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('get', 'id', id);
            const localVarPath = `/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardConfig: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/users/dashboard-config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [resourceType] Type of the resource to filter by.
         * @param {number} [resourceId] ID of the resource to filter by.
         * @param {string} [assignable] Change the results to a list of roles the user is allowed to assign to others.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyRoles: (resourceType, resourceId, assignable, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/users/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            if (resourceType !== undefined) {
                localVarQueryParameter['resourceType'] = resourceType;
            }
            if (resourceId !== undefined) {
                localVarQueryParameter['resourceId'] = resourceId;
            }
            if (assignable !== undefined) {
                localVarQueryParameter['assignable'] = assignable;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} resourceType Type of the resource.
         * @param {number} resourceId ID of the resource.
         * @param {number} [page] Page of results to return.
         * @param {number} [limit] Limit of results to return.
         * @param {string} [order] Ordering fo the results; asc or desc.
         * @param {string} [orderBy] Column to order the results by; id or surname.
         * @param {string} [attachmentMode] Include users that have indirect permission to the resource; direct, indirect or organisation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResourceUsers: (resourceType, resourceId, page, limit, order, orderBy, attachmentMode, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'resourceType' is not null or undefined
            assertParamExists('getResourceUsers', 'resourceType', resourceType);
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('getResourceUsers', 'resourceId', resourceId);
            const localVarPath = `/users/resource/{resourceType}/{resourceId}`
                .replace(`{${"resourceType"}}`, encodeURIComponent(String(resourceType)))
                .replace(`{${"resourceId"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }
            if (attachmentMode !== undefined) {
                localVarQueryParameter['attachmentMode'] = attachmentMode;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {UserResourceRoles} [userResourceRoles] Payload for removing roles from an existing user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeRoles: (id, userResourceRoles, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeRoles', 'id', id);
            const localVarPath = `/users/{id}/roles/remove`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(userResourceRoles, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [page] Page of results to return.
         * @param {number} [limit] Limit of results to return.
         * @param {number} [minLevel] Minimum user level filter.
         * @param {number} [maxLevel] Maximum user level filter.
         * @param {number} [status] User status filter.
         * @param {number} [type] User type filter.
         * @param {string} [order] Ordering for the results; asc or desc.
         * @param {string} [orderBy] Column to order the results by; eventTime, level, siteName or created.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search: (page, limit, minLevel, maxLevel, status, type, order, orderBy, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/users/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (minLevel !== undefined) {
                localVarQueryParameter['minLevel'] = minLevel;
            }
            if (maxLevel !== undefined) {
                localVarQueryParameter['maxLevel'] = maxLevel;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} term The search term.
         * @param {number} [page] Page of results to return.
         * @param {number} [limit] Limit of results to return.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchOrganisationResources: (term, page, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'term' is not null or undefined
            assertParamExists('searchOrganisationResources', 'term', term);
            const localVarPath = `/users/search-organisation-resources`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SetDashboardConfig} [setDashboardConfig] Payload for updating user dashboard config.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDashboardConfig: (setDashboardConfig, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/users/dashboard-config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(setDashboardConfig, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SetPassword} [setPassword] Payload for setting a user password.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPassword: (setPassword, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/users/password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(setPassword, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {UpdateUser} [updateUser] Payload for updating an existing user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: (id, updateUser, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id);
            const localVarPath = `/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateUser, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function (configuration) {
    const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator._delete(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {UserResourceRoles} [userResourceRoles] Payload for adding roles to an existing user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRoles(id, userResourceRoles, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addRoles(id, userResourceRoles, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {CreateUser} [createUser] Payload for creating a new user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createUser, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.create(createUser, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {Array<CreateUser>} [createUser] Payload for creating new users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBulk(createUser, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createBulk(createUser, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.get(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardConfig(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getDashboardConfig(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} [resourceType] Type of the resource to filter by.
         * @param {number} [resourceId] ID of the resource to filter by.
         * @param {string} [assignable] Change the results to a list of roles the user is allowed to assign to others.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyRoles(resourceType, resourceId, assignable, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMyRoles(resourceType, resourceId, assignable, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} resourceType Type of the resource.
         * @param {number} resourceId ID of the resource.
         * @param {number} [page] Page of results to return.
         * @param {number} [limit] Limit of results to return.
         * @param {string} [order] Ordering fo the results; asc or desc.
         * @param {string} [orderBy] Column to order the results by; id or surname.
         * @param {string} [attachmentMode] Include users that have indirect permission to the resource; direct, indirect or organisation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResourceUsers(resourceType, resourceId, page, limit, order, orderBy, attachmentMode, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getResourceUsers(resourceType, resourceId, page, limit, order, orderBy, attachmentMode, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {UserResourceRoles} [userResourceRoles] Payload for removing roles from an existing user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeRoles(id, userResourceRoles, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.removeRoles(id, userResourceRoles, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} [page] Page of results to return.
         * @param {number} [limit] Limit of results to return.
         * @param {number} [minLevel] Minimum user level filter.
         * @param {number} [maxLevel] Maximum user level filter.
         * @param {number} [status] User status filter.
         * @param {number} [type] User type filter.
         * @param {string} [order] Ordering for the results; asc or desc.
         * @param {string} [orderBy] Column to order the results by; eventTime, level, siteName or created.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search(page, limit, minLevel, maxLevel, status, type, order, orderBy, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.search(page, limit, minLevel, maxLevel, status, type, order, orderBy, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} term The search term.
         * @param {number} [page] Page of results to return.
         * @param {number} [limit] Limit of results to return.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchOrganisationResources(term, page, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchOrganisationResources(term, page, limit, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {SetDashboardConfig} [setDashboardConfig] Payload for updating user dashboard config.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDashboardConfig(setDashboardConfig, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.setDashboardConfig(setDashboardConfig, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {SetPassword} [setPassword] Payload for setting a user password.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPassword(setPassword, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.setPassword(setPassword, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {UpdateUser} [updateUser] Payload for updating an existing user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id, updateUser, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.update(id, updateUser, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = UsersApiFp(configuration);
    return {
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(id, options) {
            return localVarFp._delete(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {UserResourceRoles} [userResourceRoles] Payload for adding roles to an existing user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRoles(id, userResourceRoles, options) {
            return localVarFp.addRoles(id, userResourceRoles, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateUser} [createUser] Payload for creating a new user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createUser, options) {
            return localVarFp.create(createUser, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<CreateUser>} [createUser] Payload for creating new users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBulk(createUser, options) {
            return localVarFp.createBulk(createUser, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id, options) {
            return localVarFp.get(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardConfig(options) {
            return localVarFp.getDashboardConfig(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [resourceType] Type of the resource to filter by.
         * @param {number} [resourceId] ID of the resource to filter by.
         * @param {string} [assignable] Change the results to a list of roles the user is allowed to assign to others.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyRoles(resourceType, resourceId, assignable, options) {
            return localVarFp.getMyRoles(resourceType, resourceId, assignable, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} resourceType Type of the resource.
         * @param {number} resourceId ID of the resource.
         * @param {number} [page] Page of results to return.
         * @param {number} [limit] Limit of results to return.
         * @param {string} [order] Ordering fo the results; asc or desc.
         * @param {string} [orderBy] Column to order the results by; id or surname.
         * @param {string} [attachmentMode] Include users that have indirect permission to the resource; direct, indirect or organisation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResourceUsers(resourceType, resourceId, page, limit, order, orderBy, attachmentMode, options) {
            return localVarFp.getResourceUsers(resourceType, resourceId, page, limit, order, orderBy, attachmentMode, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {UserResourceRoles} [userResourceRoles] Payload for removing roles from an existing user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeRoles(id, userResourceRoles, options) {
            return localVarFp.removeRoles(id, userResourceRoles, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Page of results to return.
         * @param {number} [limit] Limit of results to return.
         * @param {number} [minLevel] Minimum user level filter.
         * @param {number} [maxLevel] Maximum user level filter.
         * @param {number} [status] User status filter.
         * @param {number} [type] User type filter.
         * @param {string} [order] Ordering for the results; asc or desc.
         * @param {string} [orderBy] Column to order the results by; eventTime, level, siteName or created.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search(page, limit, minLevel, maxLevel, status, type, order, orderBy, options) {
            return localVarFp.search(page, limit, minLevel, maxLevel, status, type, order, orderBy, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} term The search term.
         * @param {number} [page] Page of results to return.
         * @param {number} [limit] Limit of results to return.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchOrganisationResources(term, page, limit, options) {
            return localVarFp.searchOrganisationResources(term, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SetDashboardConfig} [setDashboardConfig] Payload for updating user dashboard config.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDashboardConfig(setDashboardConfig, options) {
            return localVarFp.setDashboardConfig(setDashboardConfig, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SetPassword} [setPassword] Payload for setting a user password.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPassword(setPassword, options) {
            return localVarFp.setPassword(setPassword, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {UpdateUser} [updateUser] Payload for updating an existing user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id, updateUser, options) {
            return localVarFp.update(id, updateUser, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    _delete(id, options) {
        return UsersApiFp(this.configuration)._delete(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {UserResourceRoles} [userResourceRoles] Payload for adding roles to an existing user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    addRoles(id, userResourceRoles, options) {
        return UsersApiFp(this.configuration).addRoles(id, userResourceRoles, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CreateUser} [createUser] Payload for creating a new user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    create(createUser, options) {
        return UsersApiFp(this.configuration).create(createUser, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<CreateUser>} [createUser] Payload for creating new users.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    createBulk(createUser, options) {
        return UsersApiFp(this.configuration).createBulk(createUser, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    get(id, options) {
        return UsersApiFp(this.configuration).get(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    getDashboardConfig(options) {
        return UsersApiFp(this.configuration).getDashboardConfig(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [resourceType] Type of the resource to filter by.
     * @param {number} [resourceId] ID of the resource to filter by.
     * @param {string} [assignable] Change the results to a list of roles the user is allowed to assign to others.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    getMyRoles(resourceType, resourceId, assignable, options) {
        return UsersApiFp(this.configuration).getMyRoles(resourceType, resourceId, assignable, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} resourceType Type of the resource.
     * @param {number} resourceId ID of the resource.
     * @param {number} [page] Page of results to return.
     * @param {number} [limit] Limit of results to return.
     * @param {string} [order] Ordering fo the results; asc or desc.
     * @param {string} [orderBy] Column to order the results by; id or surname.
     * @param {string} [attachmentMode] Include users that have indirect permission to the resource; direct, indirect or organisation.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    getResourceUsers(resourceType, resourceId, page, limit, order, orderBy, attachmentMode, options) {
        return UsersApiFp(this.configuration).getResourceUsers(resourceType, resourceId, page, limit, order, orderBy, attachmentMode, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {UserResourceRoles} [userResourceRoles] Payload for removing roles from an existing user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    removeRoles(id, userResourceRoles, options) {
        return UsersApiFp(this.configuration).removeRoles(id, userResourceRoles, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Page of results to return.
     * @param {number} [limit] Limit of results to return.
     * @param {number} [minLevel] Minimum user level filter.
     * @param {number} [maxLevel] Maximum user level filter.
     * @param {number} [status] User status filter.
     * @param {number} [type] User type filter.
     * @param {string} [order] Ordering for the results; asc or desc.
     * @param {string} [orderBy] Column to order the results by; eventTime, level, siteName or created.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    search(page, limit, minLevel, maxLevel, status, type, order, orderBy, options) {
        return UsersApiFp(this.configuration).search(page, limit, minLevel, maxLevel, status, type, order, orderBy, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} term The search term.
     * @param {number} [page] Page of results to return.
     * @param {number} [limit] Limit of results to return.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    searchOrganisationResources(term, page, limit, options) {
        return UsersApiFp(this.configuration).searchOrganisationResources(term, page, limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SetDashboardConfig} [setDashboardConfig] Payload for updating user dashboard config.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    setDashboardConfig(setDashboardConfig, options) {
        return UsersApiFp(this.configuration).setDashboardConfig(setDashboardConfig, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SetPassword} [setPassword] Payload for setting a user password.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    setPassword(setPassword, options) {
        return UsersApiFp(this.configuration).setPassword(setPassword, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {UpdateUser} [updateUser] Payload for updating an existing user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    update(id, updateUser, options) {
        return UsersApiFp(this.configuration).update(id, updateUser, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * UtilityApi - axios parameter creator
 * @export
 */
export const UtilityApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAttributeTypes: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/utility/attributes/types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [filter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCountries: (filter, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/utility/countries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} countryCode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCountryDivisions: (countryCode, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'countryCode' is not null or undefined
            assertParamExists('listCountryDivisions', 'countryCode', countryCode);
            const localVarPath = `/utility/countries/{countryCode}/divisions`
                .replace(`{${"countryCode"}}`, encodeURIComponent(String(countryCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} key
         * @param {boolean} [active] Filter the results by active or not active.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listXlatValues: (key, active, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('listXlatValues', 'key', key);
            const localVarPath = `/utility/xlats/{key}/values`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {LogEvent} [logEvent] Payload for logging an application event.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logEvent: (logEvent, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/utility/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(logEvent, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [term] The search term.
         * @param {number} [latitude] Latitude to determine distance.
         * @param {number} [longitude] Longitude to determine distance.
         * @param {number} [page] Page of results to return.
         * @param {number} [limit] Limit of results to return.
         * @param {string} [orderBy] Ordering of the result set; id or name. If lat/lng are supplied ordering will be distance.
         * @param {string} [order] Direction of the ordering; asc or desc - defaults to desc. If lat/lng are supplied direction will be asc.
         * @param {string} [timezone] IANA Timezone to filter by.
         * @param {Array<number>} [statuses] List of statuses to filter by.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchWeatherLocations: (term, latitude, longitude, page, limit, orderBy, order, timezone, statuses, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/utility/weather-locations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (latitude !== undefined) {
                localVarQueryParameter['latitude'] = latitude;
            }
            if (longitude !== undefined) {
                localVarQueryParameter['longitude'] = longitude;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (timezone !== undefined) {
                localVarQueryParameter['timezone'] = timezone;
            }
            if (statuses) {
                localVarQueryParameter['statuses'] = statuses;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * UtilityApi - functional programming interface
 * @export
 */
export const UtilityApiFp = function (configuration) {
    const localVarAxiosParamCreator = UtilityApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAttributeTypes(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listAttributeTypes(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} [filter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCountries(filter, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listCountries(filter, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} countryCode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCountryDivisions(countryCode, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listCountryDivisions(countryCode, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} key
         * @param {boolean} [active] Filter the results by active or not active.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listXlatValues(key, active, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listXlatValues(key, active, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {LogEvent} [logEvent] Payload for logging an application event.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logEvent(logEvent, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.logEvent(logEvent, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} [term] The search term.
         * @param {number} [latitude] Latitude to determine distance.
         * @param {number} [longitude] Longitude to determine distance.
         * @param {number} [page] Page of results to return.
         * @param {number} [limit] Limit of results to return.
         * @param {string} [orderBy] Ordering of the result set; id or name. If lat/lng are supplied ordering will be distance.
         * @param {string} [order] Direction of the ordering; asc or desc - defaults to desc. If lat/lng are supplied direction will be asc.
         * @param {string} [timezone] IANA Timezone to filter by.
         * @param {Array<number>} [statuses] List of statuses to filter by.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchWeatherLocations(term, latitude, longitude, page, limit, orderBy, order, timezone, statuses, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchWeatherLocations(term, latitude, longitude, page, limit, orderBy, order, timezone, statuses, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * UtilityApi - factory interface
 * @export
 */
export const UtilityApiFactory = function (configuration, basePath, axios) {
    const localVarFp = UtilityApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAttributeTypes(options) {
            return localVarFp.listAttributeTypes(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [filter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCountries(filter, options) {
            return localVarFp.listCountries(filter, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} countryCode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCountryDivisions(countryCode, options) {
            return localVarFp.listCountryDivisions(countryCode, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} key
         * @param {boolean} [active] Filter the results by active or not active.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listXlatValues(key, active, options) {
            return localVarFp.listXlatValues(key, active, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {LogEvent} [logEvent] Payload for logging an application event.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logEvent(logEvent, options) {
            return localVarFp.logEvent(logEvent, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term] The search term.
         * @param {number} [latitude] Latitude to determine distance.
         * @param {number} [longitude] Longitude to determine distance.
         * @param {number} [page] Page of results to return.
         * @param {number} [limit] Limit of results to return.
         * @param {string} [orderBy] Ordering of the result set; id or name. If lat/lng are supplied ordering will be distance.
         * @param {string} [order] Direction of the ordering; asc or desc - defaults to desc. If lat/lng are supplied direction will be asc.
         * @param {string} [timezone] IANA Timezone to filter by.
         * @param {Array<number>} [statuses] List of statuses to filter by.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchWeatherLocations(term, latitude, longitude, page, limit, orderBy, order, timezone, statuses, options) {
            return localVarFp.searchWeatherLocations(term, latitude, longitude, page, limit, orderBy, order, timezone, statuses, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * UtilityApi - object-oriented interface
 * @export
 * @class UtilityApi
 * @extends {BaseAPI}
 */
export class UtilityApi extends BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityApi
     */
    listAttributeTypes(options) {
        return UtilityApiFp(this.configuration).listAttributeTypes(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [filter]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityApi
     */
    listCountries(filter, options) {
        return UtilityApiFp(this.configuration).listCountries(filter, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} countryCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityApi
     */
    listCountryDivisions(countryCode, options) {
        return UtilityApiFp(this.configuration).listCountryDivisions(countryCode, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} key
     * @param {boolean} [active] Filter the results by active or not active.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityApi
     */
    listXlatValues(key, active, options) {
        return UtilityApiFp(this.configuration).listXlatValues(key, active, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {LogEvent} [logEvent] Payload for logging an application event.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityApi
     */
    logEvent(logEvent, options) {
        return UtilityApiFp(this.configuration).logEvent(logEvent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term] The search term.
     * @param {number} [latitude] Latitude to determine distance.
     * @param {number} [longitude] Longitude to determine distance.
     * @param {number} [page] Page of results to return.
     * @param {number} [limit] Limit of results to return.
     * @param {string} [orderBy] Ordering of the result set; id or name. If lat/lng are supplied ordering will be distance.
     * @param {string} [order] Direction of the ordering; asc or desc - defaults to desc. If lat/lng are supplied direction will be asc.
     * @param {string} [timezone] IANA Timezone to filter by.
     * @param {Array<number>} [statuses] List of statuses to filter by.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityApi
     */
    searchWeatherLocations(term, latitude, longitude, page, limit, orderBy, order, timezone, statuses, options) {
        return UtilityApiFp(this.configuration).searchWeatherLocations(term, latitude, longitude, page, limit, orderBy, order, timezone, statuses, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * VirtualMetersApi - axios parameter creator
 * @export
 */
export const VirtualMetersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CreateVirtualMeter} [createVirtualMeter] Payload for creating a new virtual meter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: (createVirtualMeter, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/virtual-meters/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createVirtualMeter, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {boolean} [attachChannels] Attach channels to the virtual meter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: (id, attachChannels, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('get', 'id', id);
            const localVarPath = `/virtual-meters/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            if (attachChannels !== undefined) {
                localVarQueryParameter['attachChannels'] = attachChannels;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {string} start The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
         * @param {string} [end] The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
         * @param {string} [aggregation] Suggested aggregation of the data. Is not guaranteed if date range is too large for the aggregation type.
         * @param {string} [grouping] Grouping of the submeters breakdown; type, group or none; default: none.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnergyBreakdown: (id, start, end, aggregation, grouping, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getEnergyBreakdown', 'id', id);
            // verify required parameter 'start' is not null or undefined
            assertParamExists('getEnergyBreakdown', 'start', start);
            const localVarPath = `/virtual-meters/{id}/energy/breakdown`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (start !== undefined) {
                localVarQueryParameter['start'] = start;
            }
            if (end !== undefined) {
                localVarQueryParameter['end'] = end;
            }
            if (aggregation !== undefined) {
                localVarQueryParameter['aggregation'] = aggregation;
            }
            if (grouping !== undefined) {
                localVarQueryParameter['grouping'] = grouping;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<string>} [categories] List of categories to filter by; grid, generator, storage or none.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTypes: (categories, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/virtual-meters/types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            if (categories) {
                localVarQueryParameter['categories'] = categories;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {SetVirtualMeterChannels} [setVirtualMeterChannels] Payload for setting channels for a virtual meter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setChannels: (id, setVirtualMeterChannels, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('setChannels', 'id', id);
            const localVarPath = `/virtual-meters/{id}/channels`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(setVirtualMeterChannels, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {UpdateVirtualMeter} [updateVirtualMeter] Payload for creating a new virtual meter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: (id, updateVirtualMeter, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id);
            const localVarPath = `/virtual-meters/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiAuthorizer required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            // authentication ApiKey required
            yield setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateVirtualMeter, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * VirtualMetersApi - functional programming interface
 * @export
 */
export const VirtualMetersApiFp = function (configuration) {
    const localVarAxiosParamCreator = VirtualMetersApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {CreateVirtualMeter} [createVirtualMeter] Payload for creating a new virtual meter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createVirtualMeter, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.create(createVirtualMeter, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {boolean} [attachChannels] Attach channels to the virtual meter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id, attachChannels, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.get(id, attachChannels, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {string} start The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
         * @param {string} [end] The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
         * @param {string} [aggregation] Suggested aggregation of the data. Is not guaranteed if date range is too large for the aggregation type.
         * @param {string} [grouping] Grouping of the submeters breakdown; type, group or none; default: none.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnergyBreakdown(id, start, end, aggregation, grouping, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getEnergyBreakdown(id, start, end, aggregation, grouping, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {Array<string>} [categories] List of categories to filter by; grid, generator, storage or none.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTypes(categories, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listTypes(categories, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {SetVirtualMeterChannels} [setVirtualMeterChannels] Payload for setting channels for a virtual meter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setChannels(id, setVirtualMeterChannels, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.setChannels(id, setVirtualMeterChannels, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {UpdateVirtualMeter} [updateVirtualMeter] Payload for creating a new virtual meter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id, updateVirtualMeter, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.update(id, updateVirtualMeter, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * VirtualMetersApi - factory interface
 * @export
 */
export const VirtualMetersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = VirtualMetersApiFp(configuration);
    return {
        /**
         *
         * @param {CreateVirtualMeter} [createVirtualMeter] Payload for creating a new virtual meter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createVirtualMeter, options) {
            return localVarFp.create(createVirtualMeter, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {boolean} [attachChannels] Attach channels to the virtual meter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id, attachChannels, options) {
            return localVarFp.get(id, attachChannels, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {string} start The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
         * @param {string} [end] The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
         * @param {string} [aggregation] Suggested aggregation of the data. Is not guaranteed if date range is too large for the aggregation type.
         * @param {string} [grouping] Grouping of the submeters breakdown; type, group or none; default: none.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnergyBreakdown(id, start, end, aggregation, grouping, options) {
            return localVarFp.getEnergyBreakdown(id, start, end, aggregation, grouping, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<string>} [categories] List of categories to filter by; grid, generator, storage or none.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTypes(categories, options) {
            return localVarFp.listTypes(categories, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {SetVirtualMeterChannels} [setVirtualMeterChannels] Payload for setting channels for a virtual meter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setChannels(id, setVirtualMeterChannels, options) {
            return localVarFp.setChannels(id, setVirtualMeterChannels, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {UpdateVirtualMeter} [updateVirtualMeter] Payload for creating a new virtual meter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id, updateVirtualMeter, options) {
            return localVarFp.update(id, updateVirtualMeter, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * VirtualMetersApi - object-oriented interface
 * @export
 * @class VirtualMetersApi
 * @extends {BaseAPI}
 */
export class VirtualMetersApi extends BaseAPI {
    /**
     *
     * @param {CreateVirtualMeter} [createVirtualMeter] Payload for creating a new virtual meter.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VirtualMetersApi
     */
    create(createVirtualMeter, options) {
        return VirtualMetersApiFp(this.configuration).create(createVirtualMeter, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {boolean} [attachChannels] Attach channels to the virtual meter.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VirtualMetersApi
     */
    get(id, attachChannels, options) {
        return VirtualMetersApiFp(this.configuration).get(id, attachChannels, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {string} start The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
     * @param {string} [end] The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
     * @param {string} [aggregation] Suggested aggregation of the data. Is not guaranteed if date range is too large for the aggregation type.
     * @param {string} [grouping] Grouping of the submeters breakdown; type, group or none; default: none.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VirtualMetersApi
     */
    getEnergyBreakdown(id, start, end, aggregation, grouping, options) {
        return VirtualMetersApiFp(this.configuration).getEnergyBreakdown(id, start, end, aggregation, grouping, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<string>} [categories] List of categories to filter by; grid, generator, storage or none.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VirtualMetersApi
     */
    listTypes(categories, options) {
        return VirtualMetersApiFp(this.configuration).listTypes(categories, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {SetVirtualMeterChannels} [setVirtualMeterChannels] Payload for setting channels for a virtual meter.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VirtualMetersApi
     */
    setChannels(id, setVirtualMeterChannels, options) {
        return VirtualMetersApiFp(this.configuration).setChannels(id, setVirtualMeterChannels, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {UpdateVirtualMeter} [updateVirtualMeter] Payload for creating a new virtual meter.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VirtualMetersApi
     */
    update(id, updateVirtualMeter, options) {
        return VirtualMetersApiFp(this.configuration).update(id, updateVirtualMeter, options).then((request) => request(this.axios, this.basePath));
    }
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@solarschools/api-sdk-typescript/dist/api.js
// module id = wM3u
// module chunks = 22